export default {
  navbar_pages: {
    stats: 'Stats',
    settings: 'Settings',
    team: 'Team',
    menu: 'Menu',
    interfaces: 'Interfaces',
    systems: 'Systems',
    forms: 'Forms',
    integrations: 'Integrations',
    profile: 'Profile',
    marketing: 'Marketing',
    marketplace: 'Marketplace',
    sms: 'SMS',

    systems_connected: 'Connected',
    systems_available: 'Available',

    orders_panel: 'Orders panel',
    admin_panel: 'Admin panel',

    telegram: 'Telegram',
    mobile_app: 'Mobile app',

    workspace: 'Workspace',
    workspace_add: 'Add workspace',
  },
  navbar: {
    quickstart: 'Quick start',
    cafe: 'Main',
    dashboard: 'Dashboard',
    general: 'General',
    stats: 'Statistics',
    menus: 'Dishes',
    delivery: 'Delivery',
    preorder: 'Takeaway',
    inside: 'Inside',
    inside_lite: 'INSIDE lite',
    preview: 'Preview',
    reserve: 'Table booking',
    reserve_new: 'Reserve',
    cafe_settings: 'Settings',
    settings: 'Account',
    top_integrations: 'Integrations',
    pos_integrations: 'POS-integrations',
    integrations: 'Marketplace',
    reviews: 'Reviews',
    workers: 'Staff',
    rooms: 'Rooms',
    loyalty: 'Loyalty program',
    discounts: 'Discounts',
    subscriptions: 'Payments',
    marketplace: 'Marketplace QR',
    help: 'Download instruction',
    logout: 'Logout',
    billing: 'Billing',
    marketing: 'Marketing',
    tools: 'Tools',
    setup: 'How to setup?',
    systems: 'QRStore',
    qrstore: 'QRWaiter Systems',
    halls: 'Halls and tables',
    notifications: 'Notifications',
    clients_base: 'Clients',
    online_payment: 'Online payment',
    hotels: 'ROOMS',
    orders_panel: 'Orders panel',
    balance: 'Balance',
    balance_table: 'Transactions history',
    sms_settings: 'SMS settings',
    sms_history: 'SMS history',
    checklists: 'Forms',
    checklists_reports: 'Reports',
    working_schedule: 'Working schedule',
    tips_settings: 'Tips',

    nomenculature_packaging: 'Packaging',

    stickers_gallery: 'Stickers gallery',

    client_orders_history: 'Orders history',

    chain_cafes: 'Cafes',
    chain_settings: 'Franchise',

    stats_orders: 'General statistics',
    stats_guests: 'Guests',
    stats_finances: 'Finances',
    stats_tables: 'Halls and tables',
    stats_average: 'Average check',

    taxes: 'Taxes',

    //corporate admin panel
    corporate_cafes: 'My cafes',
    corporate_users: 'Access',
    corporate_stats: 'Statistics',
    chain: 'Cafe franchise',
    switch_cafe: 'Change spot',

    support: 'Support',

    client_app: 'Settings',
    menu_app: 'Mobile App',
    language: 'Language',

    systems_in_your_plan: 'In your plan',
    systems_extra: 'Extra',
  },
  navigation: {
    back: 'Back',
  },
  confirm_register: {
    text: 'To create an account, come up with a strong password.',
    password: 'New password:',
    continue: 'Continue',
    repeat_password: 'Repeat new password:',

    success: 'Your account was created. Now you can log in. Redirecting...',
    error: 'An error has occured:',

    pass_strength: {
      title: `Надійність паролю`,
      '0': 'Very weak',
      '1': 'Weak',
      '2': 'Fair',
      '3': 'Strong',
      '4': 'Very strong',
    },

    init_errors: {
      not_found: 'Invalid or already used link.',
      expired: 'Link has expired. Please submit a new registration.',
    },

    errors: {
      weak: 'Your password is not secure enough.',
      mismatch: 'Your passwords do not match.',
    },

    title: 'Confirm register',
    create_password: 'Create your password',
    repeat_password: 'Repeat new password',
    create_acccount: 'Create account',
  },
  confirm_employee: {
    desc:
      'To activate the account, create a strong (at least 6 characters) password.',
    pass: 'Enter password:',
    repeat: 'Repeat new password:',
    btn: 'Activate account',
    title: 'Invite confirmation',
    hint: 'Create password for your QRWaiter account',
  },
  login: {
    email: 'Enter your e-mail',
    password: 'Enter your password',

    forgot: 'Forgot password?',
    register: 'Register',

    login: 'Log in',
    title: 'Sign in',

    via_email: 'Via email',
    via_code: 'Via code',

    code_hint: 'You can sign in via Telegram bot',
    code_get: 'Press "Get login code" in',
  },
  menu_manager: {
    title: 'Menu list',

    add_menu: '+ Add menu',
    add_menu_ph: 'Name of the new menu',

    last_edited: 'Last edited',
  },

  menus: {
    title: 'Menu Editor',
  },
  poptop: {
    title: `Top up your account`,
    sum: `Deposit amount`,
    hint: `300 UAH`,
    input: `Enter amount`,
    hintb: `500 UAH`,
    pay: `Pay`,
    back: `Back`,
  },

  menu_settings: {
    title: 'Menu settings',
    name: `Name`,
    name_hint: `This name isn't shown to the customer`,
    price: `Price`,
    weight: `Weight`,
    volume: `Volume`,
    portions_goods: `Portion`,
    weight_goods: `Weighted product`,
    semi_weight_goods: 'Weighted portion',
    non_excise_goods: `Non-excise dishes`,

    portion_desc: 'Amount of portions will be specified in order.',
    weight_desc:
      'Total weight of dish will be specified in order instead of quantity.',
    semi_weight_desc: `Amount of portions will be specified, but each portion's weight could be edited during order accept`,

    add_ingredients: `Add ingredient`,
    input_ingredients: `List the ingredients (they are not shown to guests in the online menu, but are needed for the algorithm of smart recommendations and in order to filter allergenic foods for a particular guest)`,
    excise_goods: `Excise dishes`,
    about: `Description of the dish`,
    convert: `Convert description to ingredients`,
    edit: 'Edit selected menu',
    edit_name: 'Edit name',
    save_name: 'Save name',
    duplicate: 'Duplicate',
    delete: 'Delete',
    done: `Done`,
    hint: `Main - season 2020`,
    hintb: `Bar menu`,
    webmenu: `This name will be displayed to the customer in the online menu.`,
    will_delete: `Selected addition will be removed from all dishes in which it is available. Are you sure?`,
    sale_hint: `Discount on all menu`,
    sale_hintb: `Discount will apply to all meals and drinks in this menu.`,
    preview: `Scan the QR code using your smartphone to preview the menu`,
    poster: `This menu was imported from Poster and cannot be deleted or duplicated through the menu editor. To remove this menu, you need to disable Poster integration.`,
    sale: `Discount`,
    recomendations: `Recomendations`,
    additions: `Additions`,
    addition: `Addition`,
    ingredients: `Ingredients`,
    variants: `Variants`,
    DELETE: `DELETE`,
    import_poster: `Import a dish from Poster`,
    in_poster: `Corresponding product in the Poster system`,
    poster_locked:
      'This dish was imported from Poster. Prices or modificators can be changed only in Poster.',

    modes: {
      inside: 'Order inside the cafe using QR-codes',
      preorder:
        'Customers get the opportunity to pre-order to the specific date and time by clicking on the link.',
      delivery:
        'Customers can pre-order with delivery to the specified address and time.',
    },
    duplicate_suffix: '(duplicate)',

    confirm_delete_title: 'Delete menu',
    confirm_delete: 'Are you sure you want to delete menu "{title}"?',
    cannot_reverse: 'This action cannot be undone.',
    example_menu: 'Example of filled menu',

    no_modes:
      'No systems are active. To activate a system, go to "QRWaiter Systems" section.',
    select_mode: 'Select, in what systems given menu should be enabled.',
    preview_title: 'Menu preview',

    show_exclusives: 'Recommendations in menu',
    show_exclusives_desc:
      'Separate category of recommendations, which lists top dishes in the menu. This category can also be set up manually.',

    systems: 'Systems',
  },

  menu_tag: {
    title: 'Menu title for guests',
    ph: 'Bar menu',
    desc:
      'When you have multiple menus enabled for single system, your guests can switch between them. Specify title, which will be shown to guests (e.g. "Bar menu")',
  },

  menu_editor: {
    back: 'Back',
    variants: `List the variants`,
    variant_name: `Variant name`,
    variant: `Variant`,
    gram: `Grams`,
    liter: `Liters`,
    price: `Price`,
    new_variant: `New variant`,
    additions: `List the additions`,
    addition: `Addition`,
    new_addition: `New addition`,
    languages: 'Available languages:',
    confirm_language_delete:
      'Are you sure, you want to delete this menu language?',
  },

  category_list: {
    title: 'Categories',

    add_category: '+ Add category',
    add_category_ph: 'Category name',

    new_category_ph: 'New category',

    edit: 'Edit',
    rearrange: 'Rearrange',
    done: 'Done',

    delete: 'Delete category',
    confirm_delete:
      'Are you sure you want to delete category "{name}"? This action will delete all dishes available in this category.',
  },

  menu_content_type: {
    title: 'Menu type',
    dishes: 'Dishes',
    drinks: 'Drinks',
    description:
      'Depending on the choosen type, different dish units will be used (grams / liters)',
  },

  menu_payment: {
    title: 'Merchant for online payment',
    choose_ph: '- choose merchant -',
    warning:
      'Online payment in this menu is not available. Please, select a merchant.',
    desc:
      'Select merchant, on which funds from online orders from this menu will be deposited.',
  },

  dish_list: {
    title: 'Dishes',
    add_dish: '+ Add dish',
    out_of_stock: 'Out of stock',

    rearrange: 'Rearrange',
    availability: 'Availability',
    invalid_dish: `Required fields missing`,
  },

  dish_tab: {
    title: 'Dish',

    edit: 'Edit',
    delete: 'Delete',
    done: 'Done',

    confirm_delete_title: 'Deleting dish',
    confirm_delete: 'Are you sure you want to delete dish "{name}"?',
  },

  dish_settings: {
    title: 'Dish settings',
    excise_desc:
      'Specify, whether the dish is excise. Excise products are not shown to users younger than 18 years old.',
    weighted_desc: 'Packaging price calculation depends on this option.',
    stock_disabled:
      'You cannot change stock flag for this dish, because leftovers sync with POS-system is active now.',
    in_stock: 'In stock',
    preset: 'Preset',
    preset_desc:
      'To speed up menu filling, you can select a preset and needed modifcators will be added automatically.',
    preset_dish: 'Regular dish',
    preset_pizza: 'Pizza',
    waiting_time_ph: 'Estimated cooking time (minutes)',

    weight_type: 'Weight type',

    long_units: {
      l: 'Liters',
      g: 'Grams',
      cm: 'Centimeter',
      kg: 'Kilograms',
      ml: 'Mililiters',
    },

    limits: 'Limits',

    sync_warn:
      'This menu was edited from another device.<br>Please, when using the menu edtor, work in one browser tab, do not duplicate them',

    status_saved: 'Changes saved.',
    status_saving: 'Saving changes...',
    status_error: `Dish is not shown in menu, because such required fields as names or prices are not filled in.`,

    enable_modes_description:
      'Select, in which systems this dish should be shown.',

    service_duration: 'Duration',
    service_break_time: 'Break time',
  },

  transfer_dish: {
    title: 'Move dish',
    action: 'Transfer dish',
    select_menu: 'select menu',
    select_category: 'select category',
    cancel: 'Cancel',
    confirm: 'Move',
  },

  modificators_settings: {
    title: 'Modificators settings',
    variant_name: 'Variants',
    modif_name: 'Additions',
    name_hint: 'Modificators group name',
    type_hint: 'Type',
    selection_hint: 'Multi-select',
    placeholder_optional: 'You can leave that field empty',
    placeholder_required: 'Enter name for group',
    single_select: 'Single selection (variants)',
    multi_select: 'Multiple selection (additions)',
    item_placeholder: 'Item name',
    single_select_limited: 'Selection for up to {max_count} variants',
    multi_select_limited: 'Selection for up to {max_count} additions',

    confirm_remove:
      'Are you sure you want to delete this group of modificators?',
    confirm_remove_item: 'Are you sure you want to delete this modificator?',

    allow_max_count: 'Allow selecting multiple variants',
    max_count_placeholder: 'Specify max count',

    max_count_variants_hint: 'Allow multiple selection',
    max_count_additions_hint: 'Limit maximum selection',

    placeholder_dish: 'Item name',
    placeholder_pizza: 'Pizza size (см)',

    link_btn: `Connect to other group`,

    move_up: 'Move up',
    move_down: 'Move down',
    integration: 'Integration',

    name_ph: 'Modificator',

    visible: 'Visible',

    group: 'Modificators group',

    add_modificator: 'Add modificator',
    add_group: 'Add modificator group',
    remove_group: 'Remove group',

    dependencies_title: 'Dependencies',
    dependencies_btn: 'Manage dependencies',

    dependencies_info_tip:
      'You can assign this group to another group selected modification.',

    cant_delete_group:
      'This modificators group is required in POS system and cannot be deleted.',

    dependency_self_item:
      'You can assign this modificator to another group of modificators. It will be displayed when this modificator is selected.',

    locked_changes: 'Locked changes',

    manage: 'Manage',
    setup: 'Setup',

    linked_tip_title: 'Linked dependencies',
    linked_tip_desc:
      'This modificators group is linked to other modificator. Which means, that this group will be available for selection only if at least one the following modificators is selected:',
  },

  add_modificator_group_modal: {
    add_new: 'Create new modificator group',
    add_existing: 'Add existing modificator group',
    add_existing_desc: 'Select group from list, which you would like to add.',
    merge: 'Merge',
    confirm: 'Add group',
    cancel: 'Cancel',
    select_ph: 'Select group',
  },

  modificators_merge_modal: {
    title: 'Binding a set of modifiers',
    info1:
      'You can build relationships between groups of modifiers. When selecting a particular modifier in one group, the guest will see this set of modifiers.',
    info2:
      'Select the modifier to which this group of modifiers should be bound',
    group_ph: 'Modifiers group',
    mod_ph: 'Modifier',
  },

  confirm_modal: {
    confirm: 'Yes',
    cancel: 'No',
    default: 'Are you sure?',
  },

  image_uploader: {
    default: 'CHANGE',
    edit: 'EDIT',
    delete: 'DELETE',
    default_busy: 'WAIT...',

    type_logo: 'Logotype',
    type_cover: 'Cover',

    size: 'Size',
    format: 'Format',
  },

  schedule: {
    days: {
      mon: 'Monday',
      tue: 'Tuesday',
      wed: 'Wednesday',
      thu: 'Thursday',
      fri: `Friday`,
      sat: `Saturday`,
      sun: 'Sunday',
    },

    using_default: 'This system uses default cafe schedule.',

    mode_title: 'Specific schedule',
    menu_title: 'Specific menu schedule',

    general_title: 'General working schedule',
    general_desc: 'This schedule would be applied to all system by default',

    specific_title: '{mode} working schedule',
    specific_desc: 'This settings will override general schedule',

    from: 'From',
    to: 'To',

    mode_desc:
      'If this option is disabled, {mode} system works according to general cafe schedule. You can enable it to set up mode-specific schedule.',

    menu_text:
      'You can set schedule for a menu. For example, if you cafe works until 23:00, but your kitchen menu is available until 21:00.',
  },

  nouns: {
    dishes: 'dishes',
    categories: 'categories',
    modificators: 'modificators',
  },
  units: {
    units: `Unit of measurement`,
    l: 'l.',
    g: 'g.',
    ml: 'ml.',
    kg: 'kg.',
    mins: 'мin.',
    hours: 'hrs.',
    cm: 'cm.',
    meters: 'm.',
    days: 'days',
    tariffs: 'tariff | tariffs',
  },
  error_codes: {
    subscription_form_failed: 'Failed to generate form of payment. .',
    cafe_save: `Failed to save cafe settings. Contact tech support.`,
    menu_save: `Failed to save menu. .`,
    promocode_wrong: 'Promo code is invalid.',
    packaging_empty: 'Please specify at least 1 packaging settings.',
    warehouses_error:
      'List of available Nova Poshta warehouses could not be loaded. Please refresh the page or try again later.',
    shipment_failed: 'Your order could not be placed.',
    billing_fetch: 'Failed to load balance information.',
    stats_failed: 'Failed to load statistics. .',
    poster_error: `Error integrating with Poster system. Ccontact tech support.`,
    reviews_error: 'Error loading reviews. .',
    subscription_error: 'Error loading subscriptions.',
    menu_sync: 'Menu sync required - please wait for the page to reload ...',
    menu_invalid: `To save a menu you must fill all required fields like variant and additions prices.`,
    subscription_setup_mode:
      'To make a subscription, you must completely setup selected system.',
    currency_error: 'Currency loading failed. ',
    menu_schedule: 'Menu scedule must not be larger than cafe schedule.',
    reserve_tables:
      'To save settings for RESERVE tables, you must select at least 1 table for reservations.',
    payment_error: 'Payment service error. ',
    superbilling_error: 'Billing service error.',

    promocodes_error: 'Promocodes system error. ',
    waiter_pin_exists:
      'Waiter with given PIN already exists. Please, change the PIN code.',
  },

  order_stickers: {
    templates: {
      basic: 'Modern',
      classic: 'Classic',
      hype: 'Youth',
    },
  },

  mode_settings: {
    enable: 'System',
    menu: 'Menu',
    payment: 'Payment',
    waiters: 'Staff',
    stickers: 'Stickers',
    subscription: 'Subscription',
    schedule: 'Work schedule',
    tables: 'Halls and tables',
    geolocation: 'Delivery areas',
    notifications: 'Notifications',
    address: 'Address',
    total: '',

    required: 'Required settings',
    optional: 'Optional settings',
  },
  mode_settings_hints: {
    enable: 'Enable this system',
    menu: 'Select at least one menu for this system',
    payment: 'Setup available payment methods for this system',
    waiters: 'Setup staff list for accepting orders',
    stickers: 'Order and install stickers with QR-codes',
    schedule: 'Configure work schedule',
    tables: 'Set halls and tables',
    subscription: 'Pay subscription for this systems',
    geolocation: 'Specify zones, at which your delivery works',
    notifications: 'Authorize in orders panel.',
    address: 'Specify correct cafe address',
    total: '',
  },
  stats: {
    title: `Statistics`,
    empty_desc:
      'Statistics will be shown here. To generate statistics, your cafe must work with QRWaiter system for at least 1 week.',
    loading: `Loading...`,
    general: `General`,
    currency: {
      uah: `UAH`,
      uahn: `UAH`,
    },
    clients: {
      title: `Customer base`,
      search: `Search...`,
      export: `Export`,
      import: `Import`,
      name: `Name`,
      phone: `Phone number`,
      address: `Address`,
      bonus: `Bonus account`,
      averange: `Average check`,
      first: `Ordered for the first time:`,
      returning: `Ordered again:`,
      new: `New`,
      old: `Returning`,
      choose_file_type: 'Choose file type:',
    },
    import: {
      file: `Select the file to import the customer base.`,
      csv: `CSV format is supported.`,
      max_size: `Maximum file size: 3 MB`,
      must_consist_of: `File must consist of three columns: Name, Phone and Address.`,
      example: `View an example file to import.`,
      unable_to_import: `Failed to import client database file. Make sure the file is in the correct format.`,
      choose: `Choose file...`,
      close: `Close`,
    },
    top_dishes: 'Top dishes',
    top_waiters: 'Top waiters',
    top_clients: 'Top clients',
    since: `since last month`,
    income_month: `Income per month`,
    averange: `Average check`,
    orders_month: `Orders per month`,
    orders: `orders`,
    rate: `Ratio of systems`,
    data_for: `Data for`,
    income: `Income`,
    income_for: `Income for period`,
    averange_for: `Average check for period`,
    orders_for: `Orders for period`,
    visits_for: `Visits for period`,
    view: `Views`,
    views: `Menu views`,
    order: `Orders`,
    amount: `pcs.`,
    popular: `The most popular dishes`,
    activity: `Activity`,
    guests: `Guests`,
    week: `week `,
    two_weeks: `2 weeks `,
    month: `month `,
  },
  general: {
    cafe: {
      about: `about cafe`,
      address: `address:`,
      price_policy: `Price policy:`,
      panelid: `Panel ID:`,
      menu: 'Menu',
      panel: `Orders panel:`,
      settings: `Settings`,
      no_subscriptions:
        'Active subscriptions will be displayed here, but at the moment none of the QRWaiter systems is active.',
    },
    balance: {
      marketadd: `Top up`,
      marketsettings: `Settings`,
    },
    cards: {
      inside_about_pro: `Digital menu inside the cafe with the ability to accept orders using it.`,
      inside_about: `Digital menu inside the cafe.`,
      preorder_about: `Accept "take away" orders.`,
      delivery_about: `Accept delivery orders.`,
      reserve_about: `Accept an order for a table reservation.`,
      deposit: `- ability to make deposit (online)`,
      hotels_about:
        'System for hotels, which can digitalize orders for food, drinks and event room-services.',
      info_reserve: `- ability to leave detailed information about the guest`,
      marketplace_about: `You can also accept orders and increase your customer base using the QRWaiter marketplace.`,
      marketplace_settings: `Select the systems you want to display on the marketplace:`,
      menu: `+ Digital menu for guests`,
      pt1: `- online payment`,
      pt2: `- ability to leave tip`,
      pt3: `- services`,
      pt4: `- multi-language`,
      pt5: `- smart-recomendations`,
      application: `+ Application for accepting orders for staff`,
      pro_pt1: `- Live CRM`,
      pro_pt2: `- Automatic reminders`,
      pro_pt3: `- Time trackers`,
      pro_pt4: `- Personal account for every employee`,
      qr: `QR-stickers are required for usage.`,
      link: `System uses a link to the online menu. Link can be placed in the social networks.`,
      disconnect: `Disconnect`,
      connect: `Connect`,
      settings: `Settings`,
      download_lite: 'Download sticker for INSIDE lite',
      month: 'мo.',
    },
    daily_summary: {
      new_clients: 'New clients for last month',
      new_orders: 'Orders for last month',
    },
  },
  marketplace: {
    bonus_hint: `You can give your customers bonuses from orders in your cafe. As soon as the guest accumulates enough bonuses - he will be able to pay for the order using it. You and your workers will be notified for bonus payment.`,
    bonus_amount: `Specify the size of the bonus`,
    loyalty_program: `By using the loyalty program, you agree with QRWaiter marketplace policy.`,
    no_bonus: `Select bonus percent`,
    loyalty: `Loyalty program`,
    add_balance: `Top up`,
    remind_on_low: `Remind about deposit when balances reaches less than`,
    flavors_title: 'Cafe categories',
    balance_title: 'Balance',
    balance_debt:
      'Allowed debt -30 UAH. If you reach this limit, your cafe will not be shown on the QRWaiter marketplace.',
    policy_agree:
      'By selecting any of the systems, you automatically agree with QRWaiter Marketplace policy.',
    flavors_desc:
      'Select, to which categories does your cafe belongs to. Remember, that sorting cafes in marketplace by category helps your guests to find needed cafe quicker.',
    flavors_one:
      'Your cafe will not appear in marketplace until at least 1 category is selected.',
    flavors_not_found:
      'If there is no fitting category for your cafe - contact',
    flavors_support: 'our support.',
    app_desc:
      'Scan QR-code from mobile device (via camera) or click on app store icons to download our app.',
    land_title: 'Get even more orders via marketplace QRWaiter™',
    land_connect: 'Apply',
    download_btn: 'Download app',
  },
  marketplace_policy: {
    title: 'Marketplace Policy',
    agreed: `I've read and agree`,
    agreed_link: 'with QR marketplace policy',
    link: `To make your cafe appear in marketplace, you must first agree with marketplace terms and policy.`,
  },
  settings_cafe: {
    title: `General cafe settings`,
    demo_warning:
      '! Link is in demo mode. No orders are accounted in statistics. To disable demo mode, pay a subscription. !',

    cafe_info: {
      info: `Info about cafe`,
      name: `Cafe name`,
      type: `Cafe description`,
      price_policy: `Price policy`,
      option: `Price policy`,
    },
    contacts: {
      title: `Contact information`,
      phone: `Contact phone number`,
      address: `Cafe address`,
      desc:
        'You can leave contacts for you cafe. Your guests will be able too see them in the menu.',
    },
    online_menu: {
      title: `Online menu link`,
      chain_title: 'Franchise link',
      copy_btn: 'Copy link',
      description:
        'You can put this link in your social networks profiles. This link gives access to TAKEAWAY, DELIVERY and RESERVE systems.',
      input_link: `Enter a link where your online menu can be found. You can also use this link in your social networks.`,
      input_hint: `Link can contain lowercase letters of the Latin alphabet, numbers and underscores (_).`,
      tab_domain: 'Custom domain',
      connect_domain: 'Check and connect',
      domain_ip_text:
        'You have to specify A-type DNS record in the settings of your domain registrat our server\'s IP address:  <span class="bold black-4-color">142.93.162.32</span>',
      domain_connect_text:
        'Changes in DNS records will apply in about 12 hours. After making the changes, click "Check and connect". If green checkmark appears, your menu will be available at the specified domain. SSL-certificate (https support) will be added in a few hours after initial connect',
    },
    liqpay: {
      title: `Online payment`,
      human: `Card number`,
      human_explain: `Enter the card number on which the funds for the order will be sent:`,
      company: `Company account`,
      company_explain: `Enter the account number on which the funds for the order will be sent:`,
      company_account_number: `Account number`,
      company_mfo: `MFO`,
      company_edrpoy: `EDRPOU`,
      company_name: `Company name`,
      company_tax: 'Tax ID',
      company_email: 'Company email',
      liqpay_account: `Account LiqPay`,
      liqpay_api_explain: `Enter API keys of your Liqpay account to make online payments directly to your Liqpay account:`,
      liqpay_api_pubkey: `Public API key`,
      liqpay_api_privkey: `Private API key`,
      liqpay_no_account: `Don't have a Liqpay account?`,

      liqpay_comment:
        'Comission fee 2.75%, to register you must have an open PrivatBank account',
      wayforpay_comment:
        'Comission fee 2.5%, to register you must have account in any ukranian bank',

      wayforpay_account: 'Account Wayforpay',
      wayforpay_explain:
        'Enter merchant details to make online payments directly on your account:',
      wayforpay_account_ph: 'Merchant name',
      wayforpay_secret_ph: 'Merchant secret key',
      wayforpay_register: 'Register Wayforpay merchant',
      register: `Register`,
      data_is_protected: `Your bank data is protected and not transferred to third parties`,
      confirm_tip:
        'After registration, do not forget to activate your account and ',
      apple_pay_tip: 'enable Apple Pay for your account',

      stripe_explain:
        'You can accept QRWaiter payments with Stripe. To do so, click the button to create an account and set it up.',
      stripe_active: 'Stripe account connected.',
      stripe_open_btn: 'Open Stripe dashboard',

      no_account: 'Do not have an account?',
      register_it: 'Sign up',
      comission: 'comission',

      add_receiver: 'Add merchant',
      cancel_btn: 'Cancel',
      description_ph: 'Title',
      choose_gateway: 'Choose payment gateway:',

      empty_list:
        'Add payment gateway merchant to accept payments for orders online.',

      liqpay_register_condition: 'only for Privatbank customers',
      confirm_remove:
        'Are you sure you want to delete this online payment method?',
    },
    currency: {
      title: 'Currency',
      desc: 'Select currency for your cafe:',
    },
    timezone: {
      title: 'Timezone',
      desc: 'Specify timezone for your cafe.',
    },
    social: {
      title: 'Social networks',
      desc:
        'You can place your links to your social networks, so your guests can follow them.',
      instagram: 'Instagram Link',
      facebook: 'Facebook Link',
      website: 'Website URL',
    },
  },
  subscription: {
    title_active: 'Active subscriptions',
    title: 'Subscriptions',
    inactive: `Inactive`,
    active_until: `Active until`,
    paid_until: `Paid until`,
    trial_period_until: 'Trial period until:',
    ended: `Ended`,
    cancel: `Are you sure you want to cancel the subsctiption of selected system?`,
    renew: `Renew`,
    cancl: `Cancel`,
    subscribe: `Subscribe`,
    transactions: {
      title: `Transaction history`,
      number: `Transaction number`,
      date: `Date`,
      time: `Time`,
      system: `System`,
      method: `Payment method`,
      sum: `Total`,
      commission: 'Fee',
      balance: `Balance`,
      status: `Status`,
      success: `Success`,
      error: `Error`,
      reversed: 'Returned',
      cash: `Cash`,
      terminal: `Terminal`,
      online: `Online`,
    },
    promo: {
      title: `Promocode`,
      input: `Enter a promo code for additional services or bonuses, if you have one.`,
      input_hint: `Ender promo code`,
      connect: `Connect`,
    },
    active_system_cancel:
      'You have an active subscription for this system. Do you wish to cancel it?',
  },
  workers: {
    title: `Waiters`,
    workers_editor: {
      title: `Waiters`,
      name: `Name`,
      pin: `PIN-code`,
      hint: `Add waiters and enter PIN-codes for them.`,
      add: `+ Add waiter`,
    },
    workers_queue: {
      version: 'Web version for tablets and desktops',
      title: `Orders panel`,
      id: `Orders panel ID:`,
      link: `Orders panel link: `,
      explain: `Your waiter can log in using this link with their PIN-code.`,
    },
    notifications: {
      title: `Notifications`,
      about: `Receive new order notifications instantly using Telegram bot.`,
      pt0: `To connect Telegram notifications:`,
      pt1: `1. Create chat with bot`,
      pt2: `2. Use the command`,
      pt3: `3. Enter your cafe ID -`,
      pt4: `4. Add all workers who accept orders.`,
      users_count: 'Currently there are {n} member(s) in the chat',
    },
    mobile_app: {
      ios: 'App for iOS',
      title: `Mobile app`,
      explain: `Download the application for receiving and managing orders.`,
      qr: `Scan a QR-code using your phone or press App store icon`,
    },
    admin_bot: {
      title: `Bot for administrator`,
      explain: `Connect QRWaiter Business bot to receive important notifications and reports for your place`,
      authcode: `Auth code:`,
      scan: 'Scan this QR-code to connect Telegram bot.',
    },
    guide: {
      title: 'Instruction',
      description:
        'This short manual will help your workers get started with orders panel.',
      button: 'Download manual',
    },
  },
  inside: {
    test_button: 'Test order',
    test_tooltip: 'Scan this QR code to view menu and make a test order',
    services: {
      title: `Services`,
      input_hint: `Specify additional services that the customer of the cafe can request.`,
      service_name: `Service name`,
      add: `Add service`,
    },
    geolocation: {
      title: `Geolocation`,
      switcher_optional: `Optional`,
      switcher_required: `Required`,

      off_desc:
        'Geolocation verification of your guests is disabled. Enable geolocation check, to avoid fake orders which could be made outside of the spot.',
      about: `To prevent fake orders, we will check each user's geolocation regarding your cafe. You can disable this, but in such case you take all risks regarding fake orders on yourself.`,
      disable_check: `Disable geolocation check`,
      check_disabled: `You disabled geolocation check - an order could be made right after scanning the QR-code.`,
      general_geo: `Enable required geolocation check`,
      radius_ph: 'Radius (in meters)',
      optional_geo: 'Enable optional geolocation check',
      recommended_radius: 'Recommended radius: 50 meters',
      input_general: `Put a pin on map, which corresponds to precise location of your cafe and specify radius, where stickers will work`,
    },
    halls: {
      title: `Halls and tables`,
      halln: `Hall`,
      hall_name: `Hall name`,
      tables: `Tables`,
      hall: `Add halls`,
    },
    stickers: {
      title: `You can order stickers here`,
      about: `Choose a design of stickers that would be the best for your cafe`,
      you_deside: `Digital printing is cheaper, but stickers of this type are suitable for up to 1 month.
            Wide-format printed stickers are high quality, durable, laminated and last for over a year.`,
      choose_format: `Select the print format`,
      digital: `Digital`,
      wideformat: `Wideformat`,
      order: `Order`,
      again: `one more time`,
      amount: `pcs.`,
      order_created: `Order created`,
      in_print: `Your stickers being printed`,
      is_sent: `Stickers are sent to the customer`,
      wait_wide: `Your stickers will be made within 14 days`,
      wait_digital: `Your stickers will be made within 2 working days.`,
      to_pay: `Total`,
      terms_of_delivery: `Terms of delivery`,
      nova_poshta: `QR-codes will be delivered by the Nova Poshta service.`,
      input_data: `Please provide the necessary information so that we can send you QR codes.`,
      reciver_name: `Fullname of reciver`,
      phone: `Phone number`,
      np_warehouse: `Nova Poshta warehouse`,
      choose_warehouse: `Choose warehouse`,
      online_prepay: `Online payment`,
      what_you_pay_for: `You pay for the service of printing QR-codes.`,
      pay_order: `Pay for the order`,
      return: `Return to template selection`,
      no_sections:
        'You cannot order stickers until you specify halls and tables in cafe settings.',
      is_protected: `Your bank data is protected and not transferred to third parties`,

      contacts: 'Specify your details, so we can deliver your stickers',
      name_ph: 'Recipient fullname',
      phone_ph: 'Phone number',
      address_ph: 'Address',
      comment_ph: 'Comment',

      delivery_way: 'Choose delivery method:',
      by_novaposhta: 'Nova Poshta',
      by_courier: `By courier`,

      price: 'Price of your stickers: ',
      order_button: 'Pay',

      order_accepted:
        'Your order from {date} for stickers of type {template} has been accepted.',
      choose_language: 'Choose stickers language:',
    },
    self_serve: {
      title: `Self-service`,
      if_turned_on: `Your guests will receive notification when their order is ready.`,
      turn_on: `Self-service mode`,
    },
  },
  preorder: {
    min_order_time: {
      title: `Time for cooking`,
      current:
        'Client can receive his order only after {time} since creation of the order',
      input: `Specify the minimum amount time for which the customer can pre-order.`,
    },
    time_limit: {
      title: `Work schedule`,
      zero: 'Last order will be accepted until the clousre of the cafe.',
      current: 'Last order will be accepted {time} before closure of the cafe',
      input: `Specify how many minutes before the closure of the cafe to take the last order.`,
    },
    packaging: {
      // title: `Вартість упаковки`,
      // free_packaging: `Безкоштовна упаковка`,
      // free_packaging_about: `Упаковка повністю безкоштовна і не додається клієнту в чек.`,
      // paid_packaging_fixed: `Платна упаковка (стала вартість)`,
      // paid_packaging_price: `Вартість упаковки:`,
      // no_mater: `Вказана сума завжди додається клієнту в чек, в незалежності від вибраних страв і їх кількості.`,
      // paid_packaging_percent: `Платна упаковка (змінна вартість)`,
      // paid_packaging_about: `Система автоматично обчислює загальну вартість упаковки, підбираючи розмір або об'єм упаковки під кожну страву.`,
      // volume: `Об'єм упаковки`,
      // g: `Грам`,
      // l: `Літр`,
      // price: `Вартість`,
      // price_placeholder: `30 грн`,
      // add_packaging: `Додати упаковку`,
      // ensure: `Переконайтесь, що для кожної страви знайдеться упаковка, що може її вмістити.`
      title: 'Packaging',
      type_free: 'Free packaging',
      type_non_free: 'Paid packagaing',
      type_constant: 'Fixed price',
      type_weighted: 'Variable price',

      no_variants:
        'You have empty variants group. Add a variant or remove the group to set up packaging cost.',

      dish_desc:
        "Specify size for package and it's cost. If the packaging depends on the dish weight, you  can add multiple packaging costs and our system will calculate it automatically.",

      constant_hint: 'Specified sum will be automatically added to the check.',

      unit_ph: 'Type',
      unit_l: 'Drink',
      unit_g: 'Dish',
      unit_cm: 'Pizza',

      weight_l: `Volume`,
      weight_g: 'Weight',
      weight_cm: 'Size',
      weight_null: '-',

      price_ph: 'Cost',

      add_package: 'Add package',
      type_hint: `After adding a package, specify it's type.`,

      smart_comment:
        'Packaging cost will be calculated automatically. Go to menu editor to set up packaging costs for each dish.',
      smart_btn: 'Go to menu editor',
    },
    payment: {
      title: `Payment methods`,
      cash: `Cash`,
      cash_courier: `Customer will pay in cash to courier after receipt of the order.`,
      cash_about: `Customer will pay in cash upon receipt of the order.`,
      card: `Terminal`,
      card_about: `Customer will pay by card using the terminal.`,
      online: `Online`,
      online_about: `Customer will pay for the order online by prepayment.`,
      bonus: 'Бонусами',
    },
    allow_reservation: {
      title: 'Order receiving',
      eat_in: 'Eat in',
      takeaway: 'Takeaway',
      warning: 'TAKEAWAY will not work until you select at least 1 option.',
      comment:
        'You can setup TAKEAWAY system up for your cafe. Select possible order receival ways.',
    },
  },
  delivery: {
    min_check: {
      title: `Minimum check total`,
      off_desc: 'You can set minimal check total',
      on_desc: `Guests will be able to send the order only if it's total is larger than minimal one.`,
      min_about: `Specify the minimal order price`,
    },
    max_check: {
      title: 'Max billable check total',
      desc:
        'Orders with total equal or larger than this number will have zero delivery cost for client',
    },
    price_old: {
      title: `Terms of delivery`,
      free: `Completely free delivery`,
      free_about: `Cafe pays all delivery costs.`,
      partialy_free: `Partially free delivery`,
      pfree_about: `Delivery is free after the specified price:`,
      price: `Delivery price:`,
      fixed_price: `Fixed delivery price:`,
      if_less: `If the customer makes an order less than the specified amount, the delivery cost will be automatically added to the check.`,
      tarif: `At the courier rate:`,
      if_less_courier: `If the customer makes an order less than the specified price, the delivery is paid by the customer to the courier upon receipt.`,
      paid_delivery: `Paid delivery`,
      paid_about: `Price you specify will be automatically added to the customer's check.`,
      courier: `Delivery by courier`,
      courier_about: `Customer pays for delivery upon receipt at the courier service rate.`,
      individual: `You can also order individual delivery settings.`,
    },
    price: {
      title: 'Delivery pricing',

      type_free: 'Free',
      type_conditional: 'Conditional',
      type_constant: 'Constant',

      amount_ph: 'Enter amount',

      free_after: 'Delivery is free after specified sum.',
      rules_before:
        'Delivery cost calcuation for orders lower than specified total:',

      fixed_price: 'Fixed price',
      courier_price: `Courier tariff`,
      courier_desc: `If delivery cost is calculated by courier, client pays for delivery upon receiving.`,

      add_cost_to_check: 'Add delivery price to the check',
    },
    geo: {
      title: `Delivery zones`,
      input_zones: `Specify the zones (coordinates and radius) in which delivery from your cafe works.`,
      no_zones: `No zones specified`,
      zones_hint: `Click where you want on the map to set a marker for`,
      zone_t: `zone`,
      zone: `Zone`,
      radius: `Radius`,
      add_zone: `Add zone`,
      explain: `QRWaiter automatically checks client's address and allows creating order only if it's within range of delivery zones.`,

      click_to_add: `Tap on map to create a delivery zone. Zone center is not required to be at cafe center.`,
      desc:
        'Specify delivery zones on the map. To do a more precise setting, you can add multiple zones.',
    },
  },
  reserve: {
    price: {
      title: `Paid reservations`,
      free: 'Reservation is free',
      setup: 'To enable this feature, you must setup online payment',
      input: `You can specify the booking price that the customer must pay online to confirm the booking.`,
    },
    max_days: {
      title: `Booking date`,
      input: `You can specify how many days in advance you can make a reserve.`,
    },
    max_guests: {
      title: `Amount of guests`,
      input: `You can specify the maximum number of guests for whom you can make a reserve.`,
    },
    payment: {
      title: `Payment`,
      to_card: `Transfer to card number`,
      input_card: `Enter the card number on which the funds for the order will be sent:`,
      to_bank_account: `Transfer to a bank account`,
      input_bank: `Enter the account number on which the funds for the order will be sent:`,
      account_number: `Account number (14 numbers)`,
      mfo: `MFO number`,
      edrpou: `EDRPOU code`,
      company_name: `Company name`,
      liqpay: `Transfer using LiqPay merchant`,
      api_key: `Enter API keys of your Liqpay account to make online payments directly to your Liqpay account.`,
      pubkey: `Public API key`,
      privkey: `Private API key`,
      no_liqpay: `Don't have a Liqpay account?`,
      liqpay_register: `Register`,
      data_is_protected: `Your bank data is protected and not transferred to third parties`,
    },
    allow_same_day: {
      title: 'Reservation rules',
      comment:
        'To avoid false reservations and complains from guests, reservations can be made only on the next day. But you can disable this limitation, by checking the box below.',
      toggle: 'Safe reservations',
    },
  },
  busy_modal: {
    title: 'Please wait, loading...',
  },
  menu_languages: {
    btn_add: 'Add translation',

    settings_title: 'Translations settings',
    main_language: 'Main language',
    alt_language: 'Alternative language',
    preview_title: 'Menu original preview',
    preview_desc:
      'Enable this feature to highlight untranslated texts, and see hint when entering a translation',
    remove_language_confirm: 'Are you sure you want to delete this language?',
  },
  updated_language_modal: {
    title: 'Add translation',
    subtitle: 'Select language, to which you would like to translate your menu',
    subtitle_original: 'Please, select default language for this menu',
    search: 'Search',
    btn_add: 'Add language',
    languages_plural:
      'Not selected | {n} langauge selected | {n} langauges selected',
    set_original: 'Set default language',
  },
  language_modal: {
    head: 'Add alternative language',
    choose_lang: 'Choose language for menu',
    confirm_btn: 'Add language',
    cancel_btn: 'Cancel',
    menu_lang_comment:
      'You can write translations for alternative languages in category list and dish settings. Untranslated names will be highlighted with red color.',
  },
  integrations: {
    order_title: 'Order integration',
    order_desc: `If you haven't found your POS system in the integrations list, you can leave a request for custom integration and we will set it up for you.`,
    order_button: 'Send request',
    order_ph: 'POS-system name',
    order_sent: 'Your request has been sent.',
    supported: {
      title: `Avaviable integrations`,
      you_can_connect: `You can connect a third-party accounting system to the QRWaiter system.`,
      currently_supported: `Currently supported systems (click to connect):`,
    },
    poster_settings: {
      title: `Spot`,
      choose_poster_spot: `You have multiple spots registered on your Poster account. Specify the spot in the Poster system to tablets of which QRWaiter checks will be sent.`,
      choose_spot: `choose spot`,
      term_no: `Terminal`,
      update_prices_request:
        'You have changed the Poster spot. Do you want to update prices in QRWaiter menus according to prices of the new Poster spot?',
    },
    poster_menu_input: {
      search_ph: 'Search product or dish in Poster...',
      modificator_input_none: '- no modificator -',
      modificator_input_prefix: 'Modificator',
    },
    pos_product_link: {
      title: 'Integration with POS',
      desc:
        "You can attach dish (or it's modifier) from POS system to this dish",
      has_variants: 'Dish already has variants linked to POS system',
    },
    poster_health: {
      title: 'Warning!',
      not_healthy: 'Integration is not working properly.',
      waiters_title: 'Missing employees:',
      waiters_desc:
        'QRWaiter could not create transaction in Poster correctly,, if the order is accepted by waiter, whose profile is missing in QRWaiter.',

      halls_title: 'Missing halls:',
      halls_desc:
        'QRWaiter could not create transaction in Poster on table, hall of which is missing in QRWaiter.',
    },
    poster_sync: {
      title: 'Sync',
      description:
        'Select, which entities should be sychronized automatically with Poster',
      sync_menu: 'Menu',
      sync_tables: 'Sync halls and tables',
      sync_waiters: 'Waiters',
      sync_storage: 'Storage leftovers',
      sync_transactions: 'Transactions in INSIDE',

      desc_transactions:
        'This option will sync INSIDE orders contents with Poster transactions.',
      desc_storage: 'This option will sync dish stocks with storage leftovers.',
      desc_menu:
        'This option will continously sync prices and photos for dishes and modificators in menu',
      desc_waiters:
        'New users in Poster will be automatically added to QRWaiter',
    },
    poster_instant_ui: {
      title: 'Instant orders interface',
      desc:
        'Enable this option to make orders user interface appear on Poster terminal instantly after receiving notification of new order.',
    },
    iiko_menu_input: {
      search_ph: 'Search for dish in iiko...',
    },
    poster_status: {
      title: 'Poster integration',
      active: 'Active',
      description:
        'This integrations allows to sync QRWaiter account with Poster account. Such data as menu, workers and tables will be imported automatically.',
      connect: 'Enable integration',
      // active: 'Poster integration is active.',

      disable: 'Disable integration',
      disable_modal:
        'To disable integration, go to Poster catalogue and click "Disconnect" on QRWaiter application page.',
      account_id: 'Poster account:',
      was_disconncted:
        'Poster integration with QRWaiter was disabled in Poster admin panel. To have integration working correctly, you must enable it again.',
    },
    poster_integration: {
      title: `Active integration`,
      working: `Integration with Poster works.`,
      connected: `Connected`,
      user: `by user`,
      import_title: 'Data import',
      import_hint: 'Select data, which you would like to import',
      import_menu: `Import menu`,
      import_workers: `Import staff`,
      import_halls: `Import halls and tables`,
      warning_workers: `After importing staff from Poster system, staff data in QRWaiter system will be overwritten (lost). Are you sure?`,
      warning_halls: `After importing halls and tables from Poster system, data about it in QRWaiter system will be overwritten (lost). Are you sure?`,
      warning_menu:
        'During import, two identical copies of menu called "Kitchen" and "Bar" will be created.',
    },
    poster_connect: {
      title: `Integration`,
      wait: `Please wait, integration in progress...`,
      success: `Integration complete, now you have access to new integration functions such as importing a menu.`,
      return: `Return to integrations`,
      failed: `Failed to complete integration. Try again later or contact tech support.`,
    },
    iiko_connect: {
      title: 'Integration with iiko',
      connect_btn: 'Connect integration',
      active: 'Active integration since ',
      disconnect: 'Disconnect integration',
      download: 'Download plugin',
      confirm_disconnect: 'Are you sure to cancel integartion with iiko?',
    },
    iiko_connect_modal: {
      download: '1. Download archive with our plugin for iikoFront:',
      extract:
        '2. Extract it to subfolder <span class="c-white">"Plugins/QRWaiterIikoPlugin"</span>, which can be found in iiko installation path, which by default is <span class="c-white">C:\\Program Files\\iiko\\iikoRMS\\Front.Net</span>). Eventually, file QRWaiterIikoPlugin.dll should be located at path <span class="c-white">C:\\Program Files\\iiko\\iikoRMS\\Front.Net\\Plugins \\QRWaiterIikoPlugin\\QRWaiterIikoPlugin.dll</span>',
      license:
        '3. Install 1 slot of license apiPayment <span class="c-white">(ID 21016318)</span>, it is required for QRWaiter plugin.',
      restart: '4. Restart iikoFront.',
      connect:
        '5. Open plugins menu on iikoFront, open QRWaiter menu and enter confirmation code.',

      autoclose:
        'This window will be closed automatically after successfull integration',
    },
    iiko_disconnect: {
      title: 'Please wait, disconnecting integration...',
      subtitle: 'Make sure that iikoFront is open.',
    },
    iiko_import: {
      menu_btn: 'Import menu',
      workers_btn: 'Import employees',
      tables_btn: 'Import halls and tables',

      menu_sent:
        'Menu import request has been sent. Please, make sure that iikoFront is open. Menu will be imported in a moment.',

      workers_confirm:
        'Are you sure you want to import employees info from iiko? Current settings will be overwritten.',
      tables_confirm:
        'Are you sure you want to import halls and tables info from iiko? Current settings will be overwritten.',

      workers_sent:
        'Import request has been sent. Please, make sure iikoFront is open.',
      tables_sent:
        'Import request has been sent. Please, make sure iikoFront is open.',
    },
  },
  reviews: {
    averange: `Average rating`,
    reviews: `Reviews`,
    no_reviews: 'Feedback from your guests will be shown here.',
    no_review_title: 'You don`t have any reviews yet.',
    anonymous: 'Anonymous',
  },
  settings: {
    title: `Settings`,
    mail: {
      title: `Change email`,
      current: `Current email`,
      new: `New email`,
      wait: `Please wait...`,
      confirm: `To confirm enter current password`,
      change: `Confirm change`,
      sent: `A confirmation email has been sent to the specified address.`,
      errorp: `Failed to change email. Please check that you've entered a correct password.`,
      errorl: `Failed to change email. Please check that you are using a right link.`,
      changed: `Your email address has been changed successfully. Redirecting ...`,
    },
    delete: {
      title: `Delete account`,
      pwd: `Password`,
      password: `Enter your password to delete account`,
      warn: `WARNING!`,
      warnt: `This action is irreversible and deletes all information related to your QRWaiter account: cafe, menu, order, settings, etc.`,
      unable: ` Failed to delete account. Please check that you've entered a correct password.`,
      about: `You can delete your QRWaiter account, but this action is irreversible.`,
      delete: `Delete account`,
      cancel: `Cancel`,
      deleted: `Your account was deleted, redirecting...`,
    },
    language: {
      title: `Language`,
      choose: `Select the desired language for notifications:`,
    },
    password: {
      title: `Password change`,
      current: `Current password`,
      new: `New password`,
      repeat: `Repeat new password`,
      change: `Change password`,
      success: `Your password was successfully changed!`,
      errord: `New passwords do not match`,
      erroro: `Failed to change password. Please check that you've entered a correct password.`,
    },
    two_factor: {
      title: 'Two-factor authentication',
      change_phone: 'Change phone number',
      description: 'Protect your account and enable SMS confirmation.',
      description_active:
        'An SMS with confirmation code will be sent to that number each account login.',
      checkbox: 'Enable SMS confirmation',

      set_phone_desc: 'Enter your phone number',
      set_code_desc: 'Enter code from SMS',

      confirm_phone: 'Confirm phone number',

      is_active: 'Two factor authentication is enabled.',

      confirm_code_ph: 'Confirmation code (6 digits)',

      send_sms: 'Send SMS',
    },
  },
  marketing: {
    title: 'Marketing',
    tab_campaigns: 'Ad campaigns',
    tab_loyalty: 'Loyalty program',
    tab_promocodes: 'Promocodes',
    tab_discounts: 'Discounts',

    desc_campaigns: 'Create links for ad campaigns and track their efficiency',
    desc_loyalty: 'Give your guests bonus from check total',
    desc_promocodes: 'Create promocodes for giveaways or sales',
    desc_discounts: 'Set discounts for menu products or categories',
  },
  campaign_card_old: {
    iqos_title: 'Campaign',
    title_ph: 'Campaign title',
    link: 'Link:',
    period: 'Period:',
    total_visits: 'Total menu views:',
    unique_visits: 'Total unique users:',
    delete: 'Delete campaign',
    confirm_delete: 'Are you sure you want to delete this campaign?',
    add_campaign: '+ Create link for ads campaign',
    new_campaign_ph: 'Title for new campaign',
    iqos_desc: 'Use this link for ads and watch their efficiency.',
    force_mode_none: '- do not skip system selection -',
  },
  address_details: {
    types: {
      entrance: `Entrance`,
      floor: 'Floor',
      flat: 'Flat number',
    },
    title: 'Address details',
    description: `You can additionaly ask your guests for more address details. These fields are not required.`,
    required:
      'By default, QRWaiter only asks for street name and house number.',
    description_old:
      'Specify additional address details, which client must enter to make a delivery order.',
  },
  update_bar: {
    text:
      'New dashboard update is available. Page will be reloaded in 30 seconds.',
    button: 'Reload now',
    description:
      'Specify additional address details, which client must enter to make a delivery order (these fields will be optional).',
  },
  tables: {
    orders_history: 'Orders history',
    payments_history: 'Payments history',
    search: 'Search...',
    export: 'Export',
  },
  halls_tables: {
    reserve_title: 'Tables for reservations',
    title: 'Halls and tables',
    hall_ph: 'Hall name',
    add_hall: 'Add hall',
    places_count_plural: 'place | places',
    no_halls: 'Halls and tables are not set. Click on edit button to add them.',
    places_count: 'Count',
    room: 'Room',
    not_filled: 'Not specified',
    table: 'Table',
    delete_btn: 'Delete',
    name_ph: 'Table name',
    add_btn: 'Add table',
    places_ph: 'Places count',
    remove_hall: 'Delete hall',
    confirm_remove_hall:
      'Are you sure you want to delete this hall? Stickers, printed for tables of this hall, will be disabled.',
    reserve_missing: 'Missing table for reserve',
    reserve_red_desc:
      'Red tables have not places count set up. For system RESERVE only tables with places count can be selected.',
    description:
      'Specify halls, tables and amount of available places for each table. This info is needed for calculating amount of stickers for INSIDE system and for safe reservations in RESERVE system.',
    reserve_description:
      'To allow your guests making reservations with QRWaiter, you must specify at least 1 table which is guaranteed to be free when a reservation via RESERVE is made.',
    reserve_description2:
      'Free places count is computed automatically. To change halls or tables count, go to general cafe settings.',
    pos_sync: 'Sync with POS system',
  },
  changelog: {
    title: 'Notifications from QRWaiter',
  },
  reserve_policy: {
    title: 'RESERVE Policy',
    text:
      'To be able to use RESERVE system in QRWaiter marketplace, you must read and accept our policy and terms.',
    checkbox: `I have read and accept policy for QRWaiter | RESERVE`,
  },
  corporate_employees: {
    all_permissions: {
      general: 'Cafe settings',
      stats: 'Statistics',
      marketing: 'Marketing',
      systems: 'Systems settings',
      menu: 'Menu editor',
      integrations: 'Integrations',
      payment: 'Online payment',
      '*': 'Full access',
    },
  },
  auditlog: {
    title: 'Changes history',
    columns: {
      user: 'User',
      date: 'Date',
      time: 'Time',
      action: 'Action',
    },
    select_cafe: 'Select cafe',
    types: {
      cafe_settings:
        'Changed general cafe settings ({name}, {description}, {address})',
      clients_exports: 'Exported clients base',
      pay_methods: 'Changed pay methods ({mode})',
      marketing_new_campaign: 'Created new link for ads ({title})',
      marketing_remove_campaign: 'Deleted link for ads ({title})',
      loyalty_change: 'Changed loyalty percent ({percent}%)',
      cafe_schedule: 'Changed cafe work schedule',
      online_menu_link: 'Changed cafe online menu link ({link})',
      social_links: 'Changed cafe social media links',
      waiters: 'Changed waiters settings',
      poster_import_menu: 'Imported menu from Poster',
      poster_import_tables: 'Imported tables from Poster',
      poster_import_workers: 'Imported workers from Poster',
      mode_disable: 'Disabled system ({mode})',
      mode_enable: 'Enabled system ({mode})',
      inside_services: 'Changed INSIDE call services',
      inside_geolocation: 'Changed INSIDE geolocation',
      packaging: 'Changed packaging settings ({mode})',
      delivery_price: 'Changed delivery pricing',
      reserve_allow_today: 'Changed RESERVE safe-reservation',
      menu_create: 'Created menu "{title}"',
      menu_tag: 'Edited menu tag "{tag}"',
      menu_delete: 'Deleted menu "{title}"',
      menu_duplicate: 'Duplicated menu "{title}"',
      menu_toggle: 'Changed mode "{mode}" for menu {title} ({value})',
      create_cafe: 'Created new cafe ({name}, {address})',
      regional_settings: 'Changed regional settings',
      add_employee: 'Created new user {name}, {email}',
      remove_employee: 'Deleted user {name}, {email}',
      update_employee: 'Changed settings for user {email}',
      remove_menu_product:
        'Deleted dish {name} from category {category} ({menu_title})',
      remove_menu_category:
        'Deleted category {category_name} from menu {menu_title}',
      add_online_merchant: 'Added online merchant ({gateway})',
      update_online_merchant: 'Updated online merchant',
      change_client_discounts:
        'Changed client discount settings ({client_name})',
      create_promocode: 'Created promocode',
      delete_promocode: 'Delete promocode ({count})',
      create_discount: 'Created discount',
      delete_discount: 'Deleted discount',
      change_menu_pay_receiver: 'Changed merchant for menu {menu_title}',
      change_menu_product_price: 'Changed product price {dish_name} ({price})',
      change_menu_product_photo: 'Changed product photo ({dish_name})',
      create_menu_product_modificators:
        'Created modificators group in product {dish_name}',
      delete_menu_product_modificators:
        'Deleted modfiicators group {name} from product {dish_name}',
      cancel_subscription: 'Cancelled subscription ({mode})',
      change_mode_motd: 'Changed welcome text ({mode})',
      change_reserve_price: 'Changed RESERVE price ({value})',
      change_poster_sync: 'Changed Poster sync settings',
      change_tables: 'Changed halls and tables ({halls_count} halls)',
      change_food_flavors: 'Changed marketplace categories',
      change_menu_product_integration:
        'Changed product integration settings {dish_name} ({platform})',
      transfer_menu_product: 'Transferred menu product ({dish_name})',
      delete_menu_product_modificator:
        'Deleted modificator {modificator_name} from product {dish_name}',
      change_menu_product_name: 'Renamed product {dish_name}',
    },
  },
  add_corporate_cafe: {
    modal_title: 'Creating new place',
    button: 'Add',

    tab_new: 'New',
    tab_duplicate: 'Duplicate',

    add_chain: 'Create franchise',
    chain_ph: 'Name of new chain',

    new_desc: 'Enter info about cafe, you would like to register',
    duplicate_desc:
      'Select cafe, from which we should duplicate menu, systems and their settings.',

    name_ph: 'Cafe name',
    address_ph: 'Address',

    tab_cafe: 'Cafe',
    tab_chain: 'Franchise',

    select_cafe: '- Select cafe -',

    cancel: 'Cancel',
    register: 'Create',

    no_chain: '- Independent place -',
  },
  corporate_users: {
    desc: 'You can grant access to your account with different access rights.',
    add_user: '+ Add account',
  },
  add_employee: {
    title: 'Adding account',
    add_user: 'Add user',
    comment:
      'You can grant access to admin panel of your cafe to your co-workers',
    name_ph: `Enter user fullname`,
    role_ph: 'Enter user role',
    email_ph: 'User email',
    phone_ph: 'Phone',
    choose_permissions: 'Select functions, which new user will have access to',
    choose_cafe: 'Select cafe',
    cancel: 'Cancel',
    confirm: 'Send invitation',
  },
  employee_card: {
    user_num: 'User',
    not_activated: 'User has received invitation, but has not confirmed it yet',
    cancel_invite: 'Cancel invitation',
    activated: 'User account activated ',
    delete_warning:
      'If you delete user account, his access to account will be lost.',
    delete_button: 'Delete',
    not_activated_desc: 'Invitation has been sent to user email address.',
    activated_desc:
      'Account is active, and the user has access to all given permissions.',
  },
  moeco_partner: {
    title: 'Eco delivery',
    connect_desc:
      'You can connect integration with our delivery partner "moeco". Drivers will be notified about order in advance, and you should only just cook it in time.',
    connect_btn: 'Connect "Eco" delivery',
    pending_desc: `Your request was accepted, delivery partner will get in touch with you in near future.`,
    active: 'Active eco-delivery:',
    cost: 'Delivery cost:',
    refuse_cost: 'Delivery refuse cost:',
    payer_client: 'Client pays for delivery',
    payer_cafe: 'Cafe pays for delivery',
    payer_conditional: 'Payment depends on check total',
    conditional_desc:
      'Delivery cost of order, which has a total larger than this number, will be paid by cafe.',
    conditional_example: '',

    smart_option: 'Automatic car ordering',
    manual_option: 'Manual car ordering',
    smart_desc:
      'QRWaiter will automatically order car for needed time, you just have to accept the order',
    manual_desc: 'Car must be ordered manually by specifying the waiting time.',
  },
  moeco_block: {
    title: 'Еко доставка від "Моє Таксі"',
    comment:
      'Ви можете підключити інтеграцію з нашим партнером по доставці "Моє Таксі". Водії будуть автоматично заздалегідь попереджені про нові замовлення на доставку. Вам залишиться тільки вчасно їх приготувати.',
    comment_2: 'Більше ніяких очікувань на лінії відповіді диспетчера',

    connect_btn: 'Підключити інтеграцію з "Моє Таксі" 🚀',

    request_sent:
      'Ваша заявка на підключення відправлена. Як тільки "Моє Таксі" підтвердить інтеграцію та тарифи - Ви отримаєте сповіщення.',

    ready_title: 'Оберіть режим замовлення машин для доставки',
    smart_option: 'Автоматичний',
    manual_option: 'Ручний',

    smart_desc:
      'Система QRWaiter автоматично буде замовляти машину на необхідний час, офіціанту необхідно буде лише прийняти замовлення.',
    manual_desc:
      'Для виклику машини, потрібно натиснути на кнопку "Замовити машину" в додатку для персоналу. Кнопка виклику з\'являється під кожним замовленням після його прийняття',
    price: 'Ваш тариф:',
    disconnect: 'Відключити інтеграцію з "Моє Таксі" 😕',
  },
  client_base: {
    title: 'Clients database',
    total_orders: 'Total orders',
    total_visits: 'Visits',
  },
  serving_fee: {
    title: 'Serving fee',
    enable: 'Enable serving fee',
    mode_enable: 'Enable serving fee for this system',
    percent_ph: 'Serving fee size (%)',
    comment: 'Specified comission percent will be added to every check.',
  },
  taxes_fee: {
    title: 'Taxes fee',
    enable: 'Add taxes fee to check',
    percent_ph: 'Taxes fee size (%)',
    comment: 'Specified taxes percent will be added to every check.',
  },
  taxi_price_panel: {
    limit_ph: 'Check total',
    price_ph: 'Delivery cost',
    add_button: '+ Add condition',
  },
  delivery_shipping_time: {
    title: 'Delivery time',
    comment:
      'Specify, how much time in average is needed to deliver a single order.',
  },
  guests_count_flag: {
    title: 'Cutlery count',
    ask_count: 'Ask cutlery count',
    paid_title: 'Paid cutlery',
    paid_comment:
      'You can set price for each cutlery set. Total price for them will be added to check automatically.',
    paid_ph: 'Price of 1 cutlery',
    checkbox: 'Ask for cutlery kit count when creating an order',
  },
  client_card: {
    phone: 'Phone:',
    address: 'Address:',
    bonus_balance: 'Bonus balance:',
    average_check: 'Average check:',
    total_orders: 'Total orders:',

    option_bonuses: 'Bonuses accumulation',
    option_discount: 'Set permanent discount',

    table_date: 'Date',
    table_time: 'Time',
    table_discount: 'Discount',
    table_price: 'Total',
    table_bonuses: 'Bonuses',
  },
  pay_methods: {
    cash: 'Cash',
    card: 'Card',
    online: 'Online',
  },
  workers_table: {
    add_button: 'Add',
    col_no: '№',
    col_name: `Name`,
    col_pin: `PIN-code`,

    bot_connected: 'Connected',
    bot_not_connected: 'Not connected',

    confirm_delete:
      'Are you sure you want to delete this waiter? This action cannot be undone.',
  },
  worker_profile: {
    new_ph: 'New waiter',
    orders_history: 'Orders history',
    tips_history: 'Tips history',
    tips_cafe_balance: 'On cafe account',

    phone_ph: 'Phone number',
    profile_title: 'Waiter profile',

    bot_panel_comment:
      "Scan this QR-code from waiter's phone to connect notifications",
    bot_panel_title: 'Notifications',
    bot_offline: 'Waiter has disabled notifications',

    tips_title: 'Tips balance',
    tips_comment: 'Tips, that guests paid online, will appaer here.',
    tips_payout: 'Make a payout',

    tips_card_title: 'Online tips',
    tips_card_desc:
      'Your guests can leave tips online. The funds will be sent to the waiter directly via P2P transcation..',
    tips_card_input: `Specify worker's card, on which funds will be sent.`,
    tips_technology: `You can specify waiter's custom card number to allow him receiving tips directly onto his bank account. The payment will be done as a P2P payment.`,

    attach_tables_title: 'Tables attachment',
    attach_all: 'Waiter will receive notifcations from all tables',
    attach_none: 'Waiter does not receive any notifications',
    attach_certain:
      'Waiter will receive notifications only from selected tables.',

    attach_tables_title_hotel: 'Tables attachment',
    attach_all_hotel: 'Waiter will receive notifcations from all tables',
    attach_none_hotel: 'Waiter does not receive any notifications',
    attach_certain_hotel:
      'Waiter will receive notifications only from selected tables.',

    attach_no_tables: 'You have not setup halls and tables yet.',
    attach_setup_tables: 'Set up halls and tables',

    modes_title: 'System notifications',
    modes_comment:
      'Select systems from which this worker will receive notifications',

    tipping_title: 'Tips',
    tipping_cash: 'Cash',
    tipping_online: 'Online',
    tipping_comment: `Your guests can leave tips. This feature will appear in INSIDE system after check payment.`,
    tipping_merchant:
      'Select merchant, via which tipping transactions will be made',
  },
  worker_tips_history: {
    col_date: 'Date',
    col_time: 'Time',
    col_check: 'Check',
    col_pay: 'Payment method',
    col_total: 'Total',
    col_tip: 'Tip',
    col_balance: 'Balance',
    col_discount: 'Discount',
  },
  online_payment: {
    gateways: {
      comission: 'Comission',
      pb_target: 'Only for Privatbank clients',
      any_target: 'For clients of any bank',
      payu_target: 'For clients of banks in supported countries',
      yookassa_target: 'For clients of banks in supported countries',
      stripe_target: 'For clients of banks in supported countries',
    },
    start: {
      desc:
        'You can create integration with this payment system to accept online payments',
      action: 'Create integration',
    },
    guide: {
      title: 'Connection guide',
      part1: 'To connect online payments, you must create an account.',
      part2:
        'Then you must copy Public and Private API keys, so the integration will be setup automatically.',
      part3:
        'Also, for selling products online, you must provide an offert. QRWaiter can generate it automatically, but you must specify your company details.',
      part4: 'If you do not have a merchant, you can register it.',
      register_btn: 'Register merchant',
      add_btn: 'Add merchant',
      add_btn_hint:
        'You can create another account of this payment system if you want payments from certain products to be charged on different bank account.',
    },
    help: {
      title: 'View connection guide',
      liqpay: {
        '0': 'Start merchant registartion, by specifying your phone',
        '1':
          'Fill in info about you company. In the field "Web-address", specify your online menu link: <br><a href="#" class="c-orange">{menuLink}</a>',
        '2': 'Activate the merchant, by specifying the bank account',
        '3': 'Copy-paste API keys to QRWaiter',
        '4': 'Activate Apple Pay payment by adding domain app.qrwaiter.com.ua.',
      },
      wayforpay: {
        '0': 'Click "Connect" and specify your phone number.',
        '1': 'Create new shop and choose "I am site owner" option',
        '2': 'Fill in info about your company',
        '3': 'Fill additional info and sign needed documents.',
        '4': 'Copy-paste API keys to QRWaiter.',
      },
      yookassa: {
        '0': 'Navigate to registration page',
        '1': 'Enter your phone number and fill in company details',
        '2':
          'Create test and live shops, and copy API keys (public key is shopId).',
        '3':
          'Включите HTTP-уведомления в настройках интеграции и укажите URL системы QRWaiter:<br><b>https://qrwaiter.com.ua/api/yookassa/webhook</b>',
        '4':
          'Начните заполнение и подписание документов. В качестве ссылки на сайт укажите ссылку на Ваше онлайн меню. Более детальная информация по документам доступна в <a target="_blank" class="c-green" href="https://yookassa.ru/docs/support/merchant/payments/implement/docs">документации ЮКассы.</a>',
      },
      stripe: {
        '0': 'Navigate to sign up page',
        '1': 'Enter your contact info and create an account',
        '2': 'Start account activation via side menu',
        '3': 'Fill in needed forms and documents',
        '4':
          'Copy API keys to QRWaiter. Until account activation, you can use test keys for testing integration',
        '5':
          'Click "Connect Stripe Webhook" to create payment webhook and finish integration process.',
      },
    },
    delete_merchant: 'Delete merchant',
    api_keys: {
      title: 'API Keys',
      public_ph: 'Public API keys',
      private_ph: 'Private API keys',

      invalid_title: 'Provided API keys are invalid',
      invalid_desc:
        'We could not verify the provided API keys. Please, make sure you have entered them correctly or contact support',

      test_title: 'You are using test API keys',
      test_desc:
        'You can use these keys to test online payments or for activating your merchant. All funds will be returned back to customer. To process real payments, you must specify live API keys.',
    },
    company_details: {
      title: 'Company details',
      type_ph: 'Company type',
      type_physical: 'SP',
      type_llc: 'LLC',
      name_ph: 'Company name',
      code_ph: 'Company identification number / ID',
      address_ph: 'Address',
      account_ph: 'Bank account number (optional)',
      phone_ph: 'Contact phone',
      tax_ph: 'Tax ID (optional)',
      email_ph: 'Email',
    },
    add_other_desc:
      'You can add another merchant of this payment system to accept funds for some products on another account.',
    add_other_btn: '+ Add another merchant',
    add_other_title: 'Additional account',
    menu_panel: {
      title: 'Merchant menus',
      comment:
        'For selected menus, the online payment will be done via this merchant.',
    },
  },
  regional_panel: {
    title: 'Regional settings',
    currency: 'Currency',
    timezone: 'Timezone',
    language: 'Language for notifications',
    round_menu_prices: 'Round prices in menu',
  },
  system_motd: {
    title: 'Client interface customization',
    motd_title: 'Welcome screen text',
    btn_title: 'Choose mode button title',
    popup_title: 'System name on welcome screen',
    ph: 'Write your text here',
    desc_1:
      'When your guests open system {mode}, they see default system description, delivery costs and terms of use.',
    desc_2:
      'You can add custom text to this page like special offers, tariffs or explanations.',
  },
  chain_general: {
    title: 'General info',
    name_ph: 'Name',
    desc_ph: 'Description',
  },
  chain_settings: {
    title: 'Central settings',
    option_menu: 'Menu',
    option_pos: 'POS-integrations',
    option_payment: 'Online payment',
    option_integrations: 'Third-party integrations',

    cafe_modal_title:
      'Select cafe, menus of which should be copied to the chain',
    cafe_modal_cancel: 'Cancel',
    cafe_modal_confirm: 'Enable shared menu',

    comment_1:
      'This settings can be set up globally and apply to all cafes in franchise.',
    comment_2:
      'Functions, which has no global setting, must be set up in each cafe admin panel individually.',
  },
  timing_settings: {
    title: 'Time settings',
    last_order: 'Last order',
    last_order_comment:
      'Specify, how many minutes before the closure of the cafe an order can be accepted',

    cook_time: 'Dish cooking',
    cook_time_desc: 'Specify minimal time, required to cook a single order.',

    cook_time_warning:
      'QRWaiter will show available times for ordering to your guests according to these parameters. However, the guest will receive exact ETA after the cafe accepts the order.',

    delivery_time: 'Shipping time',
    delivery_time_comment:
      'Specify minimal time required to deliver a single order.',
    delivery_time_comment2:
      'This value will be used to display estimated time of arrival for the guest.',

    time_ph: '0 min',

    gap_warning:
      "With given settings, guest won't be able to select time and make an order",
  },
  user_contacts: {
    title: 'Contact info',
    name_ph: `Name`,
    phone_ph: 'Phone number',
  },
  stickers_static: {
    title: 'Stickers',
    subtitle_none: 'To get started with the system, you have to order stickers',
    subtitle_ready: 'Stickers are activated and ready to use ✅',

    comment_none:
      '{mode} system requires special stickers. For each table a unique sticker is generated, which allows the system to recognize each table.',
    comment_none2: 'You can order stickers at QRWaiter or print them manually',

    button: 'Order designer stickers',
    download: 'Download QR-codes',
  },
  system_progress_bar: {
    not_active: 'System status',
    active: 'System is ready to use',
    suspended: 'System is not paid',
    needed: 'To get started, you must setup:',
    hint: 'You can click on the block to navigate to settings',
  },
  store_card: {
    inside: [
      'Online payment',
      'Online tips',
      'Food and services ordering',
      'Menu translations',
      'QRWaiter AI ®',
      'Geolocation verification',
      'Automatic table recognition',
      'Integrated with POS-systems',
      'Clients database generation',
    ],
    delivery: [
      'Online payment',
      'Food ordering',
      'Menu translations',
      'QRWaiter AI ®',
      'Integrated with POS-systems',
      'Integration with delivery systems',
      'Delivery zones',
      'Flexible settings for costs and tarrifs',
      'Clients database generation',
    ],
    preorder: [
      'Online payment',
      'Food ordering',
      'Menu translations',
      'QRWaiter AI ®',
      'Integrated with POS-systems',
      'Clients database generation',
    ],
    reserve: [
      'Online payment',
      'Deposit',
      'Safe-reservations',
      'Reservations calendar',
      'Integrated with POS-systems',
      'Clients database generation',
    ],
    hotels: [
      'Geolocation verification',
      'Automatic room recognition',
      'Food and services ordering',
      'QRWaiter AI ®',
      'Integrated with POS-systems',
      'Clients database generation',
    ],

    pro_title: 'All systems and features of QRWaiter in single subscription',
    pro_long: 'All systems and features of QRWaiter in single subscription',

    stickers_required: '* QR-stickers are required',

    inside_long:
      'Digital menu inside the place, which works via QR-codes attached to tables. Guests scan QR-code and get instant access to menu and ordering. Orders drop directly onto POS-terminal, and the waiter receives the notification. Also guests can order additional services and pay order online.',
    delivery_long: 'System for custom delivery',
    reserve_long: 'System for reservations',
    preorder_long: 'System for takeaway orders',
    hotels_long:
      'System for hotels, which can digitalize food and drinks ordering and even some of room service parts',

    system_status: 'System status',
    connected: 'Connected',

    subscription_status: 'Subscription status',
    trial_until: 'Trial period until',
    paid_until: 'Paid until',
    recurring_payment: 'automatic withdrawal enabled',
    ended_at: 'Ended',

    disconnect: 'Disable system',
    subscribe: 'Subscribe',

    cancel: 'Cancel subscription',
    change_card: 'Change payment card',

    trial_bonus:
      'By subscribing on the first day, you can additional free subscription week as a bonus',

    details: 'Details',
    connect: 'Connect',
    month: 'month',
  },
  new_store_card: {
    subscription_status: 'Subscription status',
    system_status: 'System status',

    status_active: 'Active',
    status_inactive: 'Inactive',
    status_subscribed: 'Subscribed',
    status_not_subscribed: 'Not active',
    status_pending_approval: 'Waiting for bank approval',

    next_payment: 'Next payment date',
    ended_at: 'Has ended',

    free: 'FREE',
    freemium_note:
      'After reaching end of trial period, you must pay a subscription for system {mode}',
    freemium_count: 'Free orders',
    trial_period: 'Free period',
    freemium_limit:
      'To continue using {mode} system, please make a paid subscription.',

    reconfirm_btn_confirm: 'Yes, cancel subscription',
    reconfirm_btn_cancel: 'No',

    subscribe_btn: 'SUBSCRIBE NOW',
    cancel_btn: 'CANCEL SUBSCRIPTION',
    change_card_btn: 'CHANGE PAYMENT CARD',
    update_payment: 'Update payment info',

    paid_till: 'Paid till',
    connected_card: 'Connected card',

    paid_text:
      'You have cancelled subscription, but you can still use system {mode} until the end of paid period.',

    reconfirm_cancel:
      'You have disabled system {mode}, but the subscription is still active. Do you wish to cancel subscription?',
    activate_refund_period: 'Activate bonus period',

    recurring_enabled: 'Payment will be processed automatically.',
    recurring_failed:
      'Your last payment failed. Please, update payment data. Your system will be disabled within {days} days.',
  },
  new_systems_features: {
    custom_page: [`🚀 Cafe personal page`, `Web Mobile | Web Desktop`],
    menu_translation: ['🌍 Automatic menu translation'],
    pos_integration: [
      '🔗 POS system synchronization',
      `• Import menu, halls, and tables, staff <br> • Synchronization of orders in online mode <br> • Synchronization of menu - photos, prices, technical cards, balances`,
    ],
    orders_panel: ['📱 Orders panel', 'Application for staff | iOS / Android'],
    inside_orders: [
      '🚀 Orders inside the cafe',
      'The system works through QR codes and automatically recognizes tables',
    ],
    online_payment: [
      '💳 Integration with payment systems',
      'For online order payment | Apple Pay / Google Pay',
    ],
    online_tips: ['💸 Online tips for staff'],
    ai: ['🤖 QRWaiter AI', 'Recommendations system based on machine-learning'],
    crm: ['👥 CRM', 'Collection of your own customer base'],
    delivery_orders: [
      '🛵 Delivery orders',
      'Setting up the entire order process',
    ],
    takeaway_orders: [
      '🌯 Takeaway orders',
      'Setting up the entire order process',
    ],
    sms_verification: ['🔒 SMS verification of customers'],
    push_notifications: ['🔔 Push notifications for order status changes'],
    reserve_orders: [
      '🛎 Table reservation</b><br>Setting up the entire order process',
    ],
    reserve_deposit: ['💰 Deposit for reservation</b>'],
    reserve_calendar: ['🗓 Reservation calendar</b>'],

    pro_inside_orders: '<b>🚀 Orders inside the place </b><br>System INSIDE',
    pro_delivery_orders: '<b>🛵 Delivery orders</b><br>System DELIVERY',
    pro_takeaway_orders: '<b>🌯 Take-away orders</b><br>System TAKEAWAY',
    pro_reserve_orders: '<b>🛎 Table reservations</b><br>System RESERVE',
  },
  stickers_card: {
    custom_comment:
      'You can download template, using which you can create custom sticker design. You can also order custom design development for your cafe.',
    download: 'Template',
    format_svg: 'File format must be .svg',
    choose_system_ph: 'Select system',
    choose_system: 'Select system for which you want to order',
    different_halls: 'You can order stickers for different halls',
    add_btn: 'Add to cart',
    choose_file: 'Choose file...',
    upload_custom: 'Upload custom design',
    uploaded: 'Uploaded',
    direct_sticker: 'Default',
    inside_sticker: 'For tables',
    added: 'Added',
    count: 'Specify target stickers count',
    count_ph: 'Stickers count',
    hall_ph: 'Hall',
    all_halls: '- All halls -',
    tables_suffix: 'tables',
    stickers_suffix: 'stickers',
  },
  stickers_checkout: {
    title: 'Cart',
    contacts: 'Contacts',
    order: 'Order',
    fullname_ph: 'Fullname of the recipient',
    firstname_ph: 'First Name',
    lastname_ph: 'Last Name',
    middlename_ph: 'Middle Name',
    phone_ph: 'Phone number',
    delivery_ph: 'Choose delivery method',
    novaposhta: 'In Nova Poshta Warehouse',
    warehouse: 'Nova Poshta Spot',
    address: 'Address',
    courier: `Courier`,
    comment: 'Comment',
    language: 'Stickers language',
    pay: 'Checkout',
    total: 'Total',

    direct_title: 'Default QR-code',

    col_design: 'Design',
    col_language: 'Language',
    col_hall: 'Hall',
    col_table: 'Table',
    col_count: 'Count',
    col_count_sub: 'per 1 table',
    col_price: 'Price',

    pay_hint: 'Your order will be sent for printing after full payment',
  },
  shipments_table: {
    statuses: {
      preparing: 'Printing',
      shipping: 'On the way',
      returned: 'Returned',
      shipped: 'Done',
    },
    recipient: 'Recipient',
    delivery: 'Address',
    contents: 'Contents',
  },
  cafe_fill_profile: {
    comment:
      'To effectively use all QRWaiter features, setup following functions:',

    params: {
      contacts: 'Cafe contacts in menu',
      online_payment: 'Online payment',
      translations: 'Menu translations',
      photos: 'Photos in menus',
      descriptions: 'Descriptions in menus',
    },

    filled_at: 'Cafe profile is filled at',
  },
  onboarding: {
    welcome: 'Thank you for choosing QRWaiter!',
    get_started: 'To get started you have to fill in some info about your spot',

    step_1:
      'Upload a logo, enter name and short description for your place. Also set the pricing policy.',

    next: 'Next',
    back: 'Back',

    name_ph: 'Name',
    desc_ph: 'Description',
    price_ph: 'Pricing level',
    type_ph: 'Type',
    type_cafe: 'Cafe, bar, restaurant, etc..',
    type_hotel: 'Hotel',

    step_2_comment:
      'Specify street name, house number, city. You can also pin the location on the map.',
    step_2: 'Now tell us your place location',

    address_ph: 'Address',

    step_3_comment: 'Specify in what days and hours your business works',
    step_3: 'Working schedule',

    step_4: 'Almost here!',
    step_4_comment:
      'Now select the currency, timezone and language for notifications.',
    step_4_hint: 'Notifications for staff, guests, admin.',

    done: 'Well done!',
    done_comment:
      'Now your place is ready to work! Setup needed systems and increase your sales in many times.',

    finish: 'Select systems',
  },
  subscribe_period: {
    title: 'Choose subscription period',
    period: 'PERIOD',
    month: 'month | months',
    price: 'MONTHLY PRICE',
    total: 'TOTAL',
    profit: 'PROFIT',
    pay: 'Checkout',
  },
  delivery_courier_delay: {
    title: `Courier call reminder`,
    desc: `Enable this option, to make staff receive reminder notification for calling courier or ordering car for deliveries`,
    ph: '0 min',
    desc_on:
      'Specify, how many minutes before the sending of the order a notificaton about calling a courier should be sent',
  },
  waiter_schedule: {
    title: 'Send order notifications',
    tab_always: 'Always',
    tab_schedule: 'By schedule',
    day_noun: '0 | 1-st day | {n}-th day',
    workday: 'Workday',
    freeday: 'Day off',
    add_btn: 'Add day',
    desc_on: `Specify watier's working schedule. If he works each second day, you can add 2 days and set the second one to be a workday, the system will plan his working times automatically.`,
    desc_off: `Setup waiter's working schedule to make him receive notifications for new orders only on working days`,
    start_date: 'Date of shifting start (employment):',
  },
  security_panel: {
    title: 'Security',
    phone: 'Verify guests phone numbers via SMS',
  },
  loyalty_view: {
    placeholder: 'Specify bonus percent',
    desc:
      'Loyalty program for your guests. They earn bonuses depending on the percent, and later can pay for orders using these bonuses.',
    stats: 'Statistics',
    bonuses_total: 'Bonuses earned',
    bonuses_used: 'Bonuses used',
  },
  campaigns_view: {
    title: 'Ad campaign',
    add_btn: 'Create campaign',
    desc: 'Create links for advertising campaigns and analyze their efficiency',
  },
  campaign_card: {
    status: 'Status:',
    active: 'Active',
    not_active: 'Inactive',
    period: 'Period:',
    link: 'Link:',
    download_qr: 'Download QR-code for link',

    stat_visits: 'Total views',
    stat_unique: 'Unique users',
    stat_orders: 'Orders',
    stat_sum: 'Total orders sum',
  },
  add_campaign: {
    title: 'Creating new ad campaign',
    name_ph: 'Campaign name',
    start_ph: 'Start date',
    end_ph: 'End date',

    cancel: 'Cancel',
    confirm: 'Create',
  },
  promocode_add_modal: {
    show_btn: 'Generate promocode',

    title: 'Promocode generation',

    max_limit: 'Max uses count per 1 client',

    tab_single: 'Single multi-use',
    tab_multi: 'Many single-use',
    count_ph: 'Count',
    custom_ph: 'Promocode (leave blank for auto generation)',
    type_ph: 'Promocode type',
    discount_ph: 'Discount (%)',
  },
  promocode_types: {
    dish_discount: 'Dish discount',
    check_discount: 'Discount',
    free_delivery: 'Free delivery',
  },
  promocode_group_card: {
    used_count: 'Uses count',
    copy_btn: 'Copy promocode',
    view_btn: 'View promocodes',
    count_ph: 'Count',
    code_ph: 'Promocode',
    delete_confirm: `Are you sure you want to delete this promocode?`,
  },
  promocodes_table: {
    title: 'Promocodes list',
    col_code: 'Code',
    col_name: 'Client name',
    col_phone: 'Client phone',
    col_status: 'Status',
    status_used: 'Used',
    status_not_used: 'Not used',
    col_date: 'Date of use',
    export_btn: 'Export',
  },
  demo_qrcode: {
    title: 'Demo mode',
    title_normal: 'Online menu',
    text: 'Scan this QR-code to view menu and make a test order.',
  },
  stats_summary: {
    guests: 'Guests count',
    orders: 'Orders count',
    average: 'Average',
    income: 'Income',
  },
  stats_chart: {
    title: 'Orders',
    conversion: 'Conversion',
    day: 'Day',
    week: 'Week',
    month: 'Month',
    label_orders: 'Orders count',
    label_views: 'Views count',
    label_bounce: 'Conversion (%)',
  },
  stats_histogram: {
    orders_title: 'Average orders count',
    hour: 'By hour',
    day: 'By day',

    average_title: 'Average',
    guests_title: 'Guests',
    finances_title: 'Average income',

    menus: 'By menu',
    sections: 'By halls',
  },
  stats_income_sources: {
    title: 'Income structure',
    by_system: 'Systems',
    by_menu: 'Menus',
    by_waiter: 'Waiters',
    by_halls: 'Halls',
  },
  stats_top_guests: {
    title: 'Top 10 guests',
    col_name: 'Name',
    col_orders: 'Orders',
    btn_all: 'View clients list',
  },
  stats_circle: {
    total: 'TOTAL',
    accepted: 'ACCEPTED',
    cancelled: 'CANCELLED',
  },
  stats_paymethods: {
    title: 'Payment method',
  },
  stats_ratios: {
    title: 'System ratios',
  },
  alerts: {
    file_too_large:
      'Selected file is too large. Maximum possible file size: 15 MB',
  },
  dish_photo_editor: {
    title: 'Photo editor',
    hint: 'Edit each photo of each size to make gray grid disappear',
    button_change: 'CHANGE',
    button_rotate: 'ROTATE',
    button_auto: 'AUTO',

    formats: 'Formats',
    format_1: '1x1 (Dish card)',
    format_2: '16x9 (Dish card)',
    format_3: '4x1 (Background photo)',

    button_save: 'SAVE',

    cancel: 'Cancel',
    process: 'Save',
  },
  add_discount: {
    btn: 'Add discount',
    title: 'Creating discount',
    all_categories: '- all categories -',
    all_products: '- all products -',
    all_modificators: '- all modificators -',
    all_menus: '- all menus -',
    discount_ph: 'Discount (%)',
  },
  discount_card: {
    delete_btn: 'Delete discount',
    period: 'Period:',
    period_from: 'from {start}',
    period_to: 'to {end}',

    applies_to_menu: 'Applies to menu {menu}',
    applies_to_category: 'to category {category}',
    applies_to_product: 'to dish {product}',

    size: 'Size:',
    title: 'Discount',
    conditions: 'Conditions:',
  },
  tables_grid: {
    heatmap: 'Tables heatmap',
    add_table: 'Add table',

    avg_orders: 'Average orders per day',
    avg_sum: 'Average check',
    avg_guests: 'Average guests count',
  },
  notification_toast: {
    error: 'Error',

    info: 'Information',
    support: 'Contact support',

    confirm: {
      copied: 'Copied',
      saved: 'Changes saved',
    },
  },
  client_profile: {
    general_title: 'General info',
    phone: 'Phone:',
    address: 'Address:',

    bonuses_title: 'Bonus collecting',
    bonuses_desc: 'You can enable bonus collecton for this client',

    discount_title: 'Permanent discount',
    discount_desc: 'You can enable permanent discount for this client',

    summary_title: 'General stats',
    summary_average: 'Average check',
    summary_total: 'Total sum',
    summary_orders: 'Orders count',
    summary_bonuses: 'Bonus balance',
    summary_period: 'Periodicity',

    summary_top_dishes: 'TOP-3 dishes',
  },
  reminder_timeout_panel: {
    title: 'Pending order reminder',
    comment: `You and your workers will receive a notification if an order won't be accepted in specified amount of minutes`,
  },
  auto_cancel_panel: {
    title: 'Automatic order cancelling',
    comment:
      'Specify time (in minutes), after which pending orders will be cancelled automatically. Guest will also receiver notification about the fact that his order has not been accepted in time.',
  },
  preorder_time_flag: {
    title: 'Forward orders',
    desc:
      'With that option enabled, guests will be able to order at specific time in couple next days. Otherwise, only ordering as soon as possible would be the only option for guests.',
  },
  poster_pending_changes: {
    title: 'New changes available',
    desc:
      'We have detected changes in Poster. Please, select which of them should be accepted or just ignore them.',

    new_product_suffix: 'new dish',
    new_price_group_suffix: 'new modificators group ',
    new_price_group_item_suffix: 'new modificator',
    remove_price_group_suffix: 'deleted modificators group',

    ignore_btn: 'Ignore',
    accept_btn: 'Accept',
  },
  danger_confirm_modal: {
    default_confirm: 'Confirm',
    default_cancel: 'Cancel',
    default_title: 'Confirmation',
  },
  info_modal: {
    default_title: 'Information',
  },
  orders_panel_download: {
    title: 'Download app for processing orders',
    id_hint: 'ID of the place:',

    web_hint:
      'Orders panel, which works via web browser on PC, tablet and mobile',
    telegram_hint: 'Sets for each waiter individually',

    btn_copy: 'Copy link',
    btn_qr: 'Show QR-code',
    btn_open: 'Open',
    btn_setup: 'Settings',
    btn_download: 'Download',
  },
  integrations_market: {
    categories: {
      pos_systems: 'POS systems',
      payment_gateways: 'Payment gateways',
      menu: 'Menu',
      delivery_partners: 'Delivery partners',
      analytics: 'Marketing and analytics',
    },
    page: {
      about: 'About',
      screenshots: 'Screenshots',
      contacts: 'Contacts',

      connect: 'Connect',
      connected: 'Connected',
      disconnect: 'Disconnect',
    },
    editor: {
      edit: 'Edit mode',
      save: 'Save changes',

      name_ph: 'Integration name',
      short_ph: 'Short description',
      desc_ph: 'Description',
      price_hint: 'Write pricing for integration',
    },
  },
  mobile_blocker: {
    title: 'Admin panel is not available on mobile devices.',
    desc: `Please, open admin panel on your PC.`,
  },
  quickstart_score: {
    desc: 'Your score of using QRWaiter',
  },
  quickstart_static: {
    title: 'Panda Que from QRWaiter',
    pt1: `You've got this!`,
    pt2: 'Continue building the basics to get the most of QRWaiter',
  },
  quickstart_options: {
    digital_menu: 'Digital menu for orders inside the place',
    online_pay_inside: 'Online payment for orders inside',
    waiter_call: 'Alternative to waiter call button',
    takeaway: 'Takeaway orders accepting',
    pager_alt: 'Food-court live-queue alternative',
    custom_delivery: 'Own delivery',
    phone_alt: 'Alternative to orders via phone call',
    reservations: 'Table reservation',
    kiosk: 'View-only digital menu without ordering',
  },
  quickstart_survey: {
    title: 'QRWaiter Systems Survey',
    done: 'Done',

    motd: 'Determine what systems fit you the best',
    start_btn: 'Take a survey',
    skip_btn: 'Mark as done',

    steps: '2 steps',
    eta: 'around 2 mins',

    select: 'Select which issues would like to fix using QRWaiter',

    confirm_btn: 'Confirm',
    connect_btn: 'Connect related systems',

    last_comment: 'After connecting related systems, you must set them up',
  },
  quickstart_setup: {
    setup_btn: 'Setup',
    pending: 'Complete all required steps to enable the system',
    ready: 'System <span class="bold">{system}</span> is ready to be used',
  },
  regular_report: {
    title: 'Regular reports',
    desc: 'You can receive regular reports of your place activity',

    select_period: 'Select period:',

    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',

    select_channel: 'Select channels:',
    channel_telegram: 'Telegram (Business bot)',
    channel_email: 'Email',
  },
  password_scores: {
    0: 'Very weak password 🤕',
    1: 'Weak password 🤕',
    2: 'Password is strong enough 💪',
    3: 'Strong password 💪',
    4: 'Password impossible to crack 🤖',
  },
  register: {
    title: 'Sign up',
    name_ph: 'Your name',
    email_ph: 'Email',
    phone_ph: 'Phone number',
    cafe_ph: 'Place name',
    address_ph: 'Place address',

    mail_sent:
      'A letter for sign up confirmation was sent to your mail <span class="bold">{email}</span>',
    change_mail: 'Change mail',

    action: 'Register',

    via_poster: 'Sign up via Poster',

    or: 'or',

    terms_agree: 'I have read and agree with Privacy Policy and Terms of Use',
  },
  password_recovery: {
    title: 'Access restore',

    restore_btn: 'Restore the password',
    back_btn: 'Back',

    sent_mail:
      'A letter with further instructions has been sent to specified mail',
  },
  tax_selector: {
    title: 'Tax',
    no_tax: '- No tax applied -',
    use_parent: 'apply menu tax',
    menu_comment: 'You can apply tax to this menu',
    comment: 'Select tax for this dish',
  },
  taxes: {
    col_name: 'Name',
    col_percent: 'Percent',
    col_type: 'Type',

    type_none: 'No tax',
    type_sales: 'Sales tax',
    type_vat: 'VAT tax',

    formula_hint: 'Calculation formula:',

    add_tax: 'Add tax',

    save_btn: 'Save',

    formula_sales: 'Sales tax = Dish price * Tax percentage',
    formula_vat: 'VAT tax = Dish price + (Dish price x VAT percentage)',

    confirm_delete: 'Are you sure you want to delete this tax?',
  },
  poster_missing_dishes: {
    title: 'Warning',
    text: 'Some dishes from this menu are not connected to Poster product.',
    view: 'View',
  },
  order_status_notification: {
    title: 'Order status notifications',
    subtitle: 'Send notifications about orders to your clients',

    push_title: 'Push-notifications',
    push_desc:
      'This type of notifications are free and may be only received via the QRWaiter Menu app. If the user does not have app installed, he will not receive any notifications',

    sms_title: 'SMS-notifications',
    sms_desc:
      'This type of notifications is paid and will only be send in case the user does not have the QRWaiter Menu app installed.',
  },
  current_balance: {
    title: 'Current balance',
    amount_ph: 'Enter amount',
    btn_topup: 'Top-up',
  },
  sms_pricing_terms: {
    title: 'Pricing terms',
    desc:
      "Price of one SMS on region of customer's phone number. You may check SMS cost for each region below",
    price: 'Price per 1 SMS',
    region: 'Region',
  },
  balance_table: {
    col_date: 'Date',
    col_time: 'Time',
    col_category: 'Category',
    col_description: 'Description',
    col_amount: 'Amount',
    col_balance: 'Balance',

    recent: 'Recent transacations',
    btn_see_all: 'View transactions history',

    categories: {
      sms: 'SMS',
      balance_topup: 'Balance topup',
      marketplace_order: 'Order in Marketplace',
    },

    sms_types: {
      order_notification: 'Order status notification',
      phone_authorization: 'Client authoriation',
      security_alert: 'Security alert',
    },

    outcome_stats: 'Outcome stats',
  },
  sms_categories: {
    title: 'SMS categories',
    active: 'Active',
    inactive: 'Inactive',

    order_status: 'Order status notifications',
    customer_verify: 'Customers verification',
    pending_orders: 'Pending orders notifications',
    security: 'Security alerts',
    marketing: 'Marketing outbounds',

    btn_setup: 'Setup',
  },
  nomenculature_packaging: {
    btn_add: 'Add packaging',

    col_name: 'Name',
    col_price: 'Price',
    col_weight: 'Max. weight',

    col_tax: 'Tax',
    col_volume: 'Volume',

    btn_save: 'Save',
    confirm_remove: 'Are you sure you want to delete this packaging?',

    param_pos_id: 'Matching item in POS system',
  },
  packaging_attachment: {
    no_default: '- no packaging -',
    default_title: 'Default packaging',
    price_hint: 'Price: {price} {currency} | Tax: {tax}%',

    custom_btn: 'Add custom',
  },
  add_custom_package: {
    title: 'Custom package',
    subtitle: 'Create unique dish configuration and set a package for it',

    price: 'Price',
    total_weight: 'Total weight',

    name_ph: 'Name for custom package',
    package_ph: 'Choose package',
    btn_add: 'Add custom package',

    combination_exists: 'Selected dish configuration already exists',
  },
  sms_history: {
    btn_open: 'View SMS history',

    col_date: 'Date',
    col_time: 'Time',
    col_type: 'Type',
    col_text: 'Text',
    col_segments: 'Segments',
    col_receiver: 'Receiver',
    col_cost: 'Cost',
    col_balance: 'Balance',
  },
  client_authorization: {
    title: `Client's number verification via SMS`,
    subtitle: 'We will send a unique code to client to verify phone number',

    text1:
      'This is paid function. The cost for each SMS will be charged from your balance automatically.',
    text2:
      'We use smart-verification, which means that system will remember what device was used to confirm phone number, which reduces total amount of sent SMS',
  },
  system_card: {
    active: 'Active',
    inactive: 'Inactive',
  },
  subscription_status_panel: {
    motto_inside: 'Online ordering system inside restaurant',
    motto_preorder: 'Online system for takeaway orders',
    motto_delivery: 'Online system for deliveries',
    motto_reserve: 'Online table booking',
    motto_preview: 'Online readonly menu page',

    promo_title: 'Hi there!',
    promo_text: 'You have 14 trial days to test',
    promo_warn:
      'Please note, that once you start the trial, you will not be able to pause it',

    btn_trial: 'Start a trial',
    btn_subscribe: 'Subscribe',
    btn_cancel: 'Cancel subscription',
    btn_cancel_approval: 'Cancel card approval',
    btn_change_card: 'Change card',
    btn_view_invoices: 'View invoices',
    btn_renew: 'Renew subscription',

    param_subscription: 'Subscription',
    param_trial: 'Trial period',
    param_status: 'Subscription status',
    param_paid: 'Cancelled',
    param_card: 'Connected card',
    param_date: 'Payment date',

    period_year: 'Annual',
    period_month: 'Monthly',
    paid_period: 'Paid period | Till ',

    status_approval: 'Waiting for bank approval',
    trial_end: 'Ended',
    days_left: 'days left',

    desc_trial:
      'After ending of free period, you will need to pay a monthly subscription to use system ',
    desc_trial_end:
      'Your free period has ended. You need to pay monthly subscription to continue using the system',
    desc_approval: 'Your system will be active once we process your payment.',
    desc_active: '* Payment will be processed automatically',
    desc_paid:
      'Your subscription was cancelled, but you still can use system {system} until the end of paid period',
    desc_failed:
      'Your regular monthly payment has failed. We will try to charge your card 3 more times (once per day). Otherwise, your subscription will be cancelled',

    feedback_text:
      'We will be pleased, if you would share with us your experience of using QRWaiter',
    feedback_btn: 'Leave feedback',

    ended_title: 'Ended at',

    ended_thanks: 'Thank you!',
    ended_subtitle: 'It was a great time!',

    failed_attempt_1: '1st payment attempt',
    failed_attempt_2: '2nd payment attempt',
    failed_attempt_3: '3rd payment attempt',
    failed_attempt_4: '4rd payment attempt',

    charge_later:
      'If you subscribe now, we will make first charge of your funds at the end of trial period',
  },
  pos_sync_tooltip: {
    title: 'Synchronization',

    btn_sync: 'Sync',

    manual_sync: 'Manual',
    manual_sync_desc:
      'You can manually sync your menu with POS-system if needed',
    manual_done: 'Done',

    menu_sync: 'Auto-sync',
    menu_sync_desc:
      'System will check for updates in POS-system and update them automatically',
    storage_sync: 'Storage leftovers',
    storage_sync_desc:
      'You can sync your storage leftovers with the menu. Only in-stock items will be shown to guest',
  },
  pos_pending_changes_tooltip: {
    title: 'Changelog',
    tab_new: 'New',
    tab_ignored: 'Ignored',

    no_changes: 'All changes are synced',
    no_changes_sub: 'No action needed',

    type_added: 'Added',

    btn_select_all: 'Select all',
  },
  iqos_actions: {
    save: 'Save',
  },
  pos_storage_leftovers_popup: {
    title: 'Hidden items',

    items_hidden:
      'You have {count} dishes hidden due to storage leftovers synchronization',
    choose_action: 'Please, choose what to do with these items',

    btn_hide: 'Keep hidden',
    btn_show: 'Show in menu',
  },
  checklists: {
    btn_new: 'New Form',
    search_ph: 'Search...',
    filter_all: 'All',
    forms_noun: '{n} form | {n} forms',
    last_edited: 'Last edited',
    tab_forms: 'Templates',
    tab_reports: 'Reports',
  },

  checklist_editor: {
    new_ph: 'New form',
    badge_draft: 'Draft',
    badge_live: 'Live',
    badge_edited: 'Edited',

    tab_content: 'Content',
    tab_schedule: 'Schedule',
    tab_assign: 'Assign',

    btn_delete: 'Delete form',
    btn_copy: 'Copy form',
    btn_save: 'Publish changes',
    btn_publish: 'Publish',
    btn_unpublish: 'Unpublish',
    btn_preview: 'Preview',

    add_tag_ph: 'Add tag...',

    title_ph: 'Name your form...',
    desc_ph: 'Describe your form...',

    type_scheduled: 'Scheduled',
    type_adhoc: 'Ad-hoc',

    type_scheduled_desc: 'To be shown on schedule',
    type_adhoc_desc: 'To be completed anytime needed',

    type_adhoc_content: 'The form will be always available for completion',

    btn_add_schedule: 'Add schedule',

    members_noun: '{n} team member | {n} team members',
    schedules_noun: '{n} schedule | {n} schedules',

    btn_add_member: 'Add team member',

    team_search_ph: 'Search team...',
    assign_ph: 'Assign team member',

    copied: 'Form copied. You are now editing the new one',
    delete_title:
      'Are you sure you want to <div class="del">delete</div> the form?',
    delete_subtitle: 'All data will be lost.',
    delete_cancel: 'Cancel',
    delete_confirm: 'Delete form',

    save_title: 'Do you want to save changes?',
    save_subtitle: 'Otherwise all changes would be lost.',
    save_cancel: "Don't save",
    save_confirm: 'Save changes',
  },
  checklist_toolbar: {
    text: 'Text',
    divider: 'Divider',
    image: 'Image',
    document: 'File',
    checklist: 'Checklist section',
    input: 'Text section',
    number: 'Number section',
    options: 'Options',
    file: 'File upload',
  },
  checklist_blocks: {
    title_ph: 'Title',
    text: {
      btn_save: 'Save',
    },
    input: {
      title: 'Text section',
      ph: '',
    },
    file: {
      title: 'Attachment',
    },
    options: {
      title: 'Options',
      item_ph: 'Option item',
      btn_add: 'Add option',
      display_as: 'Display as',
      as_dropdown: 'Dropdown',
      as_buttons: 'Buttons',
      score_ph: 'Score',
    },
    checklist: {
      title: 'Checklist section',
      btn_add: 'Add checklist item',
      item_ph: 'Checklist item',

      setting_required: 'All items must be marked as complete',
      setting_comment: 'Ask user for comment when marking item as incomplete',
      setting_addable: 'Users may add their own items',
    },
    number: {
      title: 'Number',
      subtitle: 'Enter weight, currency, temperature, etc.',
      prefix_title: 'Prefix / suffix',
      prefix_desc:
        'You may add symbols before or after the number to indicate units of measurement',
      number_ph: 'Number',
      prefix_ph: 'Prefix',
      suffix_ph: 'Suffix',

      range_title: 'Acceptable range',
      range_desc: 'You may set acceptable range for the number value',
      range_min: 'Min',
      range_max: 'Max',
    },
    settings: {
      required: 'Required',
      required_desc:
        'Required fields must be filled in order to complete this form',

      scores: 'Scores',
      scores_desc: 'Assign a score to each option towards some total',

      cached: 'Save last entered value',

      assign_title: 'Assign section to option',
      assign_add: 'Add option',
      assign_search: 'Search options',
    },
  },
  checklist_schedule: {
    type_scheduled: 'Scheduled',
    type_repeat: 'Repeatable',

    start_date: 'Start date',
    start_time: 'Start timeslot',
    end_time: 'End timeslot',

    repeatable: 'Repeat',
    repeat_every: 'Repeat every',

    save: 'Save',

    from: 'From',
    to: 'to',

    day: 'Day',
    week: 'Week',
    month: 'Month',
    year: 'Year',

    weekday_names: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    month_names: [
      'january',
      'february',
      'march',
      'april',
      'may',
      'june',
      'july',
      'august',
      'september',
      'october',
      'november',
      'december',
    ],
  },
  checklist_report_blocks: {
    required: `Required`,
    value_ph: 'No value',
    score: 'Score',
    completed: 'Completed',
    uncompleted: 'Uncompleted',
    not_applicable: 'Not applicable',

    no_file: 'No file uploaded',
  },
  checklist_reports: {
    completeness: 'Completeness',
    scheduled: 'Scheduled',
    expired: 'Expired',
    total_score: 'Total score',
    report_time: 'Report time',
    none_score: 'None',

    checklist_stats: 'Completed checklists',

    completeness_hint: 'Counted based on the amount of required sections',

    empty_title: 'No reports found',
    empty_subtitle: 'at selected date',
  },
  reserve_deposit_settings: {
    title: 'Reservation deposit',
    subtitle: 'Your guests will pay a deposit to confirm the reservation',
    mode_full: 'Full price of selected services',
    mode_constant: 'Fixed price',
    mode_percent: 'Percentage of selected services total price',
  },
  phone_confirmation_panel: {
    title: 'Phone verification',
    subtitle: "We will verify client's phone number using SMS",
    warning: 'This is a paid feature. Visit SMS outbound settings for pricing.',
    more: 'More',
  },
  iiko_auto_settings: {
    online_title: 'Auto-close online paid orders',
    online_subtitle:
      'This option will have online paid orders be automatically closed in iiko',

    select_counterparty: 'Select counterparty (user) to use for closing order',
    none: '-- no counterparty --',
  },
  auto_accept: {
    title: 'Auto-accept orders',
    subtitle: `You can set a waiter, on which all incoming orders will be automatically accepted`,

    select_ph: '-- select waiter --',
  },
  public_beta: {
    title: 'Menu App 2.0',
    desc:
      'Experience a fresh, user-friendly design with seamless navigation and innovative features. To try it out, simply toggle on this option. Feel free to share feedback to help us improve the experience. You can switch back to the previous interface anytime by toggling off this option. Enjoy exploring the new interface!',
    feedback: 'We would be happy to hear feedback about new interface',
    supported_in: 'Currently, the new interface is support in systems',
  },
  superbilling: {
    tab_plan: 'Plan',
    tab_details: 'Details and notifications',

    valid_till: 'Workspace is valid until',
    pricing_plan: 'Pricing plan',
    payment_sum: 'Payment sum',
    every_month: 'Every month',
    every_year: 'Every year',

    free_period: 'Free period',

    services_noun: 'services',
    calendar_day: 'th calendar day',

    invoices: 'Invoices',

    invoice_id: 'Invoice ID',
    due_date: 'Due date',
    services: 'Services',
    sum: 'Sum',
    payment_method: 'Payment method',
    status: 'Status',

    paid: 'Paid',
    unpaid: 'Unpaid',
    refunded: 'Refunded',

    card: 'Card',
    bank_transfer: 'Bank transfer',

    pay_invoice: 'Pay invoice',

    change_plan: 'Change pricing plan',

    recipient: 'Recipient',

    auto_payment: 'Auto payment',
    ap_status: 'Status',
    ap_enabled: 'Enabled',
    ap_disable: 'Disable',
    ap_card: 'Assigned card',
    ap_change: 'Change',
    ap_next_payment: 'Next payment',
    ap_attempt: 'th payment attempt',
    ap_more: 'More',
    ap_less: 'Less',
    ap_warning:
      ' If the first attempt to proceed the payment fail, we will try to proceed it 3 more times (1 time per day). If all four attempts fail, the auto payment will be canceled.',

    empty_hint: 'Choose the right plan for your business',
    empty_select: 'Choose plan',

    confirm_disable: 'Are you sure you want to disable autopayment?',

    next_payment: 'Next payment',
  },
  billing_company_details: {
    title: 'Company details',
    subtitle:
      'Fill in your details to receive invoices for your QRWaiter subscription payments and the legal agreement.',

    type: 'Company type',
    name: 'Company name',
    vat_id: 'Company VAT ID',
    address: 'Company address',
    delivery_address: 'Document delivery address',

    sp: 'SP',
    llc: 'LLC',
  },
  billing_reminders_panel: {
    title: 'Reminders about subscription extending',
    subtitle:
      'Enter one or several email addresses so that your accountant or other employees also receive the reminder 3 days before the subscription is expired. If you pay the subscription by bank transfer, the payment bill will be sent to your email address.',

    list: 'Email addresses for reminders',
    add: 'Add Address',
  },
  pay_invoice_modal: {
    invoice: 'Invoice',
    service: 'Service',
    period: 'Period',
    subscription: 'Subscription',
    sum: 'Sum',

    monthly: 'Monthly',
    yearly: 'Yearly',
    total: 'Total',
    payment_type: 'Payment type',
    by_card: 'Pay by card',
    by_bank: 'Bank transfer',

    auto_payment: 'Auto payment',
    ap_hint:
      'The amount will be charged from your card automatically every billing cycle',

    pay_now: 'Pay now',

    bank: 'Bank',
    payment_description: 'Payment description',
    description_ph: 'Payment for invoice',
    warning:
      'Please, keep the same description of the payment, so our system will recognize it automatically. Account will be activated, once we receive your payment.',
  },
  select_plan_modal: {
    title: 'Pricing plan',
    subtitle: 'Select the plan which fits your business needs.',
    monthly: 'Monthly',
    annually: 'Annually',
    most_popular: 'MOST POPULAR',

    month: 'month',
    year: 'year',

    selected: 'SELECTED PLAN',
    select: 'SELECT PLAN',

    plan: 'Plan',

    cancel: 'Cancel',
    confirm: 'Confirm',
    summary: 'Summary',

    autocancel_hint:
      'Note: if you change your billing plan, your auto-payment will be canceled. To resume automatic payment for your QRWaiter subscription, please sign up for auto-payment again',

    lite_desc:
      'The Lite Plan offers a simple, digital menu display through QR code or link, ideal for those needing just a basic digital menu service.',
    dynamic_desc:
      'The Dynamic Plan provides flexibility, allowing you to select and pay for only the services you need: Inside, Takeaway, Delivery',
    smart_desc:
      ' The Smart Plan is a comprehensive package with all four services included, offered at a total cost lower than selecting all individually on the Dynamic Plan.',
  },
  superbilling_system_card: {
    active: 'Active',
    inactive: 'Inactive',

    banner_title: 'Upgrade your pricing plan',
    banner_text:
      'You current plan does not include this system. You need to update the pricing plan to use this system.',
    banner_btn: 'Update plan',

    checklist_title: 'Setup checklist',
    checklist_hint: 'Complete this checklist to make the system work',
  },
  failed_payment_banner: {
    text: 'Payment failed. Please update your payment details.',
    btn: 'Update payment details',
  },
  disable_system_modal: {
    title: 'System off-schedule',
    question: 'How do you want to turn on the system next time?',
    mode_manual: 'Manually',
    mode_auto: 'Automatically on selected date',

    auto_date: 'When should the system turn-on?',

    hint_manual: 'System will be disabled until you manually turn it on',
    hint_auto: 'System will automatically turn on at',

    confirm_btn: 'Confirm',

    preliminary_title: 'Pre-orders while the system is off',
    preliminary_desc:
      'Your guests will be able to make pre-order for the time when the system will be able nex time. So you can collect pre-orders ahead.',
  },
  tips_settings: {
    title: 'Tipping',
    subtitle: 'A function that will ask your guests to leave a tip',
    turn_on: 'Turn on',
    turn_off: 'Turn off',
  },
  tips_mode_panel: {
    title: 'Tipping mode',
    subtitle: 'Choose how you want this feature to work',

    option_corporate: 'Corporate',
    option_corporate_desc:
      'Tipping will be added to the order amount and will be paid to your account along with the order receipt',

    option_personal: 'Personal',
    option_personal_desc:
      'Guests will leave the tip themselves by choosing someone from your staff. The tip will be sent directly to the waiter via a link.',
  },
  tips_merchant_panel: {
    title: 'Merchant',
    subtitle: 'Please select the account to which the tip should be credited',
  },
  tips_systems_panel: {
    title: 'Systems',
    subtitle: 'You can select the systems in which the tip will work',
  },
  tips_team_panel: {
    title: 'Team',
    subtitle:
      'Customize tips for each member of your team by providing a link to leave a tip',
    link: 'Link',
    role_ph: 'Waiter',
  },
  request_integration: {
    btn: 'Request integration',
    description:
      "If you haven't found the integration you need, you can submit a request for its development. Integrations for which we receive a large number of requests are prioritized for development and will be available as soon as possible",
    name_ph: 'Integration name',
    send: 'Send',
    success: 'Your integration request has been successfully submitted',
  },
  delivery_tariffs: {
    title: 'Delivery price',
    subtitle: 'Set up the price conditions for the delivery service',

    type_free: 'Free',
    type_paid: 'Paid',

    mode_title: 'Tariffication mode',
    mode_custom: 'Custom',
    mode_partner: 'Delivery Partner',

    tariff: 'Tariff',
    prop_name: 'Name',
    prop_price: 'Price',
    prop_zone: 'Zone',
    name_ph: 'Tariff name',
    btn_add: 'Add',
  },
};
